// Recovered compiled webpack factory 29695. Edit this function expression; run npm run build.
(e, t, r) => {
  let n, i, s, o, a, l;
  r.d(t, { w: () => rB });
  var c,
    u = r(49636),
    d = r(2332),
    h = r(73314),
    p = r(60567),
    f = r(87624),
    m = r(81611),
    y = r(43275),
    g = (r(12398), r(27122)),
    S = r(28385),
    v = r(2257),
    _ = r(51290),
    w = r(89135),
    b = r(10160),
    k = r(35868),
    E = r(54058),
    M = r(31209),
    I = r(71350),
    C = r(42106),
    R = r(88722),
    T = r(97684),
    x = r(40364),
    O = r(7755),
    D = r(75784),
    N = r(97309),
    A = r(62234),
    L = r(7916),
    P = r(79152);
  let F = u.O,
    B = "sentryReplaySession",
    U = "Unable to send Replay";
  var z = Object.defineProperty,
    W = (e, t, r) =>
      ((e, t, r) =>
        t in e
          ? z(e, t, { enumerable: !0, configurable: !0, writable: !0, value: r })
          : (e[t] = r))(e, "symbol" != typeof t ? t + "" : t, r),
    j = ((e) => (
      (e[(e.Document = 0)] = "Document"),
      (e[(e.DocumentType = 1)] = "DocumentType"),
      (e[(e.Element = 2)] = "Element"),
      (e[(e.Text = 3)] = "Text"),
      (e[(e.CDATA = 4)] = "CDATA"),
      (e[(e.Comment = 5)] = "Comment"),
      e
    ))(j || {});
  function H(e) {
    let t = e?.host;
    return t?.shadowRoot === e;
  }
  function $(e) {
    return "[object ShadowRoot]" === Object.prototype.toString.call(e);
  }
  function q(e) {
    try {
      var t;
      let r = e.rules || e.cssRules;
      return r
        ? ((t = Array.from(r, K).join("")).includes(" background-clip: text;") &&
            !t.includes(" -webkit-background-clip: text;") &&
            (t = t.replace(
              /\sbackground-clip:\s*text;/g,
              " -webkit-background-clip: text; background-clip: text;",
            )),
          t)
        : null;
    } catch (e) {
      return null;
    }
  }
  function K(e) {
    let t;
    if ("styleSheet" in e)
      try {
        t =
          q(e.styleSheet) ||
          (function (e) {
            let { cssText: t } = e;
            if (t.split('"').length < 3) return t;
            let r = ["@import", `url(${JSON.stringify(e.href)})`];
            return (
              "" === e.layerName ? r.push("layer") : e.layerName && r.push(`layer(${e.layerName})`),
              e.supportsText && r.push(`supports(${e.supportsText})`),
              e.media.length && r.push(e.media.mediaText),
              r.join(" ") + ";"
            );
          })(e);
      } catch (e) {}
    else if ("selectorText" in e) {
      let t = e.cssText,
        r = e.selectorText.includes(":"),
        n = "string" == typeof e.style.all && e.style.all;
      if (
        (n &&
          (t = (function (e) {
            let t = "";
            for (let r = 0; r < e.style.length; r++) {
              let n = e.style,
                i = n[r],
                s = n.getPropertyPriority(i);
              t += `${i}:${n.getPropertyValue(i)}${s ? " !important" : ""};`;
            }
            return `${e.selectorText} { ${t} }`;
          })(e)),
        r && (t = t.replace(/(\[(?:[\w-]+)[^\\])(:(?:[\w-]+)\])/gm, "$1\\$2")),
        r || n)
      )
        return t;
    }
    return t || e.cssText;
  }
  class V {
    constructor() {
      (W(this, "idNodeMap", new Map()), W(this, "nodeMetaMap", new WeakMap()));
    }
    getId(e) {
      return e ? (this.getMeta(e)?.id ?? -1) : -1;
    }
    getNode(e) {
      return this.idNodeMap.get(e) || null;
    }
    getIds() {
      return Array.from(this.idNodeMap.keys());
    }
    getMeta(e) {
      return this.nodeMetaMap.get(e) || null;
    }
    removeNodeFromMap(e) {
      let t = this.getId(e);
      (this.idNodeMap.delete(t),
        e.childNodes && e.childNodes.forEach((e) => this.removeNodeFromMap(e)));
    }
    has(e) {
      return this.idNodeMap.has(e);
    }
    hasNode(e) {
      return this.nodeMetaMap.has(e);
    }
    add(e, t) {
      let r = t.id;
      (this.idNodeMap.set(r, e), this.nodeMetaMap.set(e, t));
    }
    replace(e, t) {
      let r = this.getNode(e);
      if (r) {
        let e = this.nodeMetaMap.get(r);
        e && this.nodeMetaMap.set(t, e);
      }
      this.idNodeMap.set(e, t);
    }
    reset() {
      ((this.idNodeMap = new Map()), (this.nodeMetaMap = new WeakMap()));
    }
  }
  function J({ maskInputOptions: e, tagName: t, type: r }) {
    return (
      "OPTION" === t && (t = "SELECT"),
      !!(e[t.toLowerCase()] || (r && e[r]) || "password" === r || ("INPUT" === t && !r && e.text))
    );
  }
  function G({ isMasked: e, element: t, value: r, maskInputFn: n }) {
    let i = r || "";
    return e ? (n && (i = n(i, t)), "*".repeat(i.length)) : i;
  }
  function Y(e) {
    return e.toLowerCase();
  }
  function X(e) {
    return e.toUpperCase();
  }
  let Q = "__rrweb_original__";
  function Z(e) {
    let t = e.type;
    return e.hasAttribute("data-rr-is-password") ? "password" : t ? Y(t) : null;
  }
  function ee(e, t, r) {
    return "INPUT" === t && ("radio" === r || "checkbox" === r)
      ? e.getAttribute("value") || ""
      : e.value;
  }
  function et(e, t) {
    let r;
    try {
      r = new URL(e, t ?? window.location.href);
    } catch (e) {
      return null;
    }
    let n = r.pathname.match(/\.([0-9a-z]+)(?:$)/i);
    return n?.[1] ?? null;
  }
  let er = {};
  function en(e) {
    let t = er[e];
    if (t) return t;
    let r = window.document,
      n = window[e];
    if (r && "function" == typeof r.createElement)
      try {
        let t = r.createElement("iframe");
        ((t.hidden = !0), r.head.appendChild(t));
        let i = t.contentWindow;
        (i && i[e] && (n = i[e]), r.head.removeChild(t));
      } catch (e) {}
    return (er[e] = n.bind(window));
  }
  function ei(...e) {
    return en("setTimeout")(...e);
  }
  function es(...e) {
    return en("clearTimeout")(...e);
  }
  function eo(e) {
    try {
      return e.contentDocument;
    } catch (e) {}
  }
  let ea = 1,
    el = RegExp("[^a-z0-9-_:]");
  function ec() {
    return ea++;
  }
  let eu = /url\((?:(')([^']*)'|(")(.*?)"|([^)]*))\)/gm,
    ed = /^(?:[a-z+]+:)?\/\//i,
    eh = /^www\..*/i,
    ep = /^(data:)([^,]*),(.*)/i;
  function ef(e, t) {
    return (e || "").replace(eu, (e, r, n, i, s, o) => {
      let a = n || s || o,
        l = r || i || "";
      if (!a) return e;
      if (ed.test(a) || eh.test(a) || ep.test(a)) return `url(${l}${a}${l})`;
      if ("/" === a[0])
        return `url(${l}${(t.indexOf("//") > -1 ? t.split("/").slice(0, 3).join("/") : t.split("/")[0]).split("?")[0] + a}${l})`;
      let c = t.split("/"),
        u = a.split("/");
      for (let e of (c.pop(), u))
        if ("." === e) continue;
        else ".." === e ? c.pop() : c.push(e);
      return `url(${l}${c.join("/")}${l})`;
    });
  }
  let em = /^[^ \t\n\r\u000c]+/,
    ey = /^[, \t\n\r\u000c]+/,
    eg = new WeakMap();
  function eS(e, t) {
    return t && "" !== t.trim() ? ev(e, t) : t;
  }
  function ev(e, t) {
    let r = eg.get(e);
    if ((r || ((r = e.createElement("a")), eg.set(e, r)), t)) {
      if (t.startsWith("blob:") || t.startsWith("data:")) return t;
    } else t = "";
    return (r.setAttribute("href", t), r.href);
  }
  function e_(e, t, r, n, i, s, o) {
    if (!n) return n;
    if (
      "src" === r ||
      ("href" === r && ("use" !== t || "#" !== n[0])) ||
      ("xlink:href" === r && "#" !== n[0])
    )
      return eS(e, n);
    if ("background" === r && ("table" === t || "td" === t || "th" === t)) return eS(e, n);
    if ("srcset" === r)
      return (function (e, t) {
        if ("" === t.trim()) return t;
        let r = 0;
        function n(e) {
          let n,
            i = e.exec(t.substring(r));
          return i ? ((n = i[0]), (r += n.length), n) : "";
        }
        let i = [];
        for (; n(ey), !(r >= t.length); ) {
          let s = n(em);
          if ("," === s.slice(-1)) ((s = eS(e, s.substring(0, s.length - 1))), i.push(s));
          else {
            let n = "";
            s = eS(e, s);
            let o = !1;
            for (;;) {
              let e = t.charAt(r);
              if ("" === e) {
                i.push((s + n).trim());
                break;
              }
              if (o) ")" === e && (o = !1);
              else if ("," === e) {
                ((r += 1), i.push((s + n).trim()));
                break;
              } else "(" === e && (o = !0);
              ((n += e), (r += 1));
            }
          }
        }
        return i.join(", ");
      })(e, n);
    if ("style" === r) {
      let t = ef(n, ev(e));
      return (
        o &&
          o.size > 0 &&
          (t = (function (e, t) {
            if (!e || 0 === t.size) return e;
            try {
              let r = e.split(";"),
                n = [];
              for (let e of r) {
                if (!(e = e.trim())) continue;
                let r = e.indexOf(":");
                if (-1 === r) {
                  n.push(e);
                  continue;
                }
                let i = e.slice(0, r).trim();
                t.has(i) || n.push(e);
              }
              return n.join("; ") + (n.length > 0 && e.endsWith(";") ? ";" : "");
            } catch (t) {
              return (console.warn("Error filtering CSS properties:", t), e);
            }
          })(t, o)),
        t
      );
    } else if ("object" === t && "data" === r) return eS(e, n);
    return "function" == typeof s ? s(r, n, i) : n;
  }
  function ew(e, t, r) {
    return ("video" === e || "audio" === e) && "autoplay" === t;
  }
  function eb(e, t, r = 1 / 0, n = 0) {
    return !e || e.nodeType !== e.ELEMENT_NODE || n > r
      ? -1
      : t(e)
        ? n
        : eb(e.parentNode, t, r, n + 1);
  }
  function ek(e, t) {
    return (r) => {
      if (null === r) return !1;
      try {
        if (e) {
          if ("string" == typeof e) {
            if (r.matches(`.${e}`)) return !0;
          } else if (
            (function (e, t) {
              for (let r = e.classList.length; r--; ) {
                let n = e.classList[r];
                if (t.test(n)) return !0;
              }
              return !1;
            })(r, e)
          )
            return !0;
        }
        if (t && r.matches(t)) return !0;
        return !1;
      } catch {
        return !1;
      }
    };
  }
  function eE(e, t, r, n, i, s) {
    try {
      let o = e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
      if (null === o) return !1;
      if ("INPUT" === o.tagName) {
        let e = o.getAttribute("autocomplete");
        if (
          [
            "current-password",
            "new-password",
            "cc-number",
            "cc-exp",
            "cc-exp-month",
            "cc-exp-year",
            "cc-csc",
          ].includes(e)
        )
          return !0;
      }
      let a = -1,
        l = -1;
      if (s) {
        if ((l = eb(o, ek(n, i))) < 0) return !0;
        a = eb(o, ek(t, r), l >= 0 ? l : 1 / 0);
      } else {
        if ((a = eb(o, ek(t, r))) < 0) return !1;
        l = eb(o, ek(n, i), a >= 0 ? a : 1 / 0);
      }
      return a >= 0 ? !(l >= 0) || a <= l : !(l >= 0) && !!s;
    } catch (e) {}
    return !!s;
  }
  function eM(e) {
    return null == e ? "" : e.toLowerCase();
  }
  function eI(e, t) {
    let r,
      {
        doc: s,
        mirror: o,
        blockClass: a,
        blockSelector: l,
        unblockSelector: c,
        maskAllText: u,
        maskTextClass: d,
        unmaskTextClass: h,
        maskTextSelector: p,
        unmaskTextSelector: f,
        skipChild: m = !1,
        inlineStylesheet: y = !0,
        maskInputOptions: g = {},
        maskAttributeFn: S,
        maskTextFn: v,
        maskInputFn: _,
        slimDOMOptions: w,
        dataURLOptions: b = {},
        inlineImages: k = !1,
        recordCanvas: E = !1,
        onSerialize: M,
        onIframeLoad: I,
        iframeLoadTimeout: C = 5e3,
        onBlockedImageLoad: R,
        onStylesheetLoad: T,
        stylesheetLoadTimeout: x = 5e3,
        keepIframeSrcFn: O = () => !1,
        newlyAddedElement: D = !1,
        ignoreCSSAttributes: N,
      } = t,
      { preserveWhiteSpace: A = !0 } = t,
      L = (function (e, t) {
        let {
            doc: r,
            mirror: s,
            blockClass: o,
            blockSelector: a,
            unblockSelector: l,
            maskAllText: c,
            maskAttributeFn: u,
            maskTextClass: d,
            unmaskTextClass: h,
            maskTextSelector: p,
            unmaskTextSelector: f,
            inlineStylesheet: m,
            maskInputOptions: y = {},
            maskTextFn: g,
            maskInputFn: S,
            dataURLOptions: v = {},
            inlineImages: _,
            recordCanvas: w,
            keepIframeSrcFn: b,
            newlyAddedElement: k = !1,
            ignoreCSSAttributes: E,
          } = t,
          M = (function (e, t) {
            if (!t.hasNode(e)) return;
            let r = t.getId(e);
            return 1 === r ? void 0 : r;
          })(r, s);
        switch (e.nodeType) {
          case e.DOCUMENT_NODE:
            if ("CSS1Compat" !== e.compatMode)
              return { type: j.Document, childNodes: [], compatMode: e.compatMode };
            return { type: j.Document, childNodes: [] };
          case e.DOCUMENT_TYPE_NODE:
            return {
              type: j.DocumentType,
              name: e.name,
              publicId: e.publicId,
              systemId: e.systemId,
              rootId: M,
            };
          case e.ELEMENT_NODE:
            return (function (e, t) {
              let r,
                {
                  doc: s,
                  blockClass: o,
                  blockSelector: a,
                  unblockSelector: l,
                  inlineStylesheet: c,
                  maskInputOptions: u = {},
                  maskAttributeFn: d,
                  maskInputFn: h,
                  dataURLOptions: p = {},
                  inlineImages: f,
                  recordCanvas: m,
                  keepIframeSrcFn: y,
                  newlyAddedElement: g = !1,
                  rootId: S,
                  maskTextClass: v,
                  unmaskTextClass: _,
                  maskTextSelector: w,
                  unmaskTextSelector: b,
                  ignoreCSSAttributes: k,
                } = t,
                E = (function (e, t, r, n) {
                  try {
                    if (n && e.matches(n)) return !1;
                    if ("string" == typeof t) {
                      if (e.classList.contains(t)) return !0;
                    } else
                      for (let r = e.classList.length; r--; ) {
                        let n = e.classList[r];
                        if (t.test(n)) return !0;
                      }
                    if (r) return e.matches(r);
                  } catch (e) {}
                  return !1;
                })(e, o, a, l),
                M = (function (e) {
                  if (e instanceof HTMLFormElement) return "form";
                  let t = Y(e.tagName);
                  return el.test(t) ? "div" : t;
                })(e),
                I = {},
                C = e.attributes.length;
              for (let t = 0; t < C; t++) {
                let r = e.attributes[t];
                r.name &&
                  !ew(M, r.name, r.value) &&
                  (I[r.name] = e_(s, M, Y(r.name), r.value, e, d, k));
              }
              if ("link" === M && c) {
                let t = Array.from(s.styleSheets).find((t) => t.href === e.href),
                  r = null;
                (t && (r = q(t)),
                  r &&
                    ((I.rel = null),
                    (I.href = null),
                    (I.crossorigin = null),
                    (I._cssText = ef(r, t.href))));
              }
              if ("style" === M && e.sheet && !(e.innerText || e.textContent || "").trim().length) {
                let t = q(e.sheet);
                t && (I._cssText = ef(t, ev(s)));
              }
              if ("input" === M || "textarea" === M || "select" === M || "option" === M) {
                let t = Z(e),
                  r = ee(e, X(M), t),
                  n = e.checked;
                if ("submit" !== t && "button" !== t && r) {
                  let n = eE(e, v, w, _, b, J({ type: t, tagName: X(M), maskInputOptions: u }));
                  I.value = G({ isMasked: n, element: e, value: r, maskInputFn: h });
                }
                n && (I.checked = n);
              }
              if (
                ("option" === M &&
                  (e.selected && !u.select ? (I.selected = !0) : delete I.selected),
                "canvas" === M && m)
              ) {
                if ("2d" === e.__context)
                  !(function (e) {
                    let t = e.getContext("2d");
                    if (!t) return !0;
                    for (let r = 0; r < e.width; r += 50)
                      for (let n = 0; n < e.height; n += 50) {
                        let i = t.getImageData;
                        if (
                          new Uint32Array(
                            (Q in i ? i[Q] : i).call(
                              t,
                              r,
                              n,
                              Math.min(50, e.width - r),
                              Math.min(50, e.height - n),
                            ).data.buffer,
                          ).some((e) => 0 !== e)
                        )
                          return !1;
                      }
                    return !0;
                  })(e) && (I.rr_dataURL = e.toDataURL(p.type, p.quality));
                else if (!("__context" in e)) {
                  let t = e.toDataURL(p.type, p.quality),
                    r = s.createElement("canvas");
                  ((r.width = e.width),
                    (r.height = e.height),
                    t !== r.toDataURL(p.type, p.quality) && (I.rr_dataURL = t));
                }
              }
              if ("img" === M && f) {
                n || (i = (n = s.createElement("canvas")).getContext("2d"));
                let t = e.currentSrc || e.getAttribute("src") || "<unknown-src>",
                  r = e.crossOrigin,
                  o = () => {
                    e.removeEventListener("load", o);
                    try {
                      ((n.width = e.naturalWidth),
                        (n.height = e.naturalHeight),
                        i.drawImage(e, 0, 0),
                        (I.rr_dataURL = n.toDataURL(p.type, p.quality)));
                    } catch (r) {
                      if ("anonymous" !== e.crossOrigin) {
                        ((e.crossOrigin = "anonymous"),
                          e.complete && 0 !== e.naturalWidth ? o() : e.addEventListener("load", o));
                        return;
                      }
                      console.warn(`Cannot inline img src=${t}! Error: ${r}`);
                    }
                    "anonymous" === e.crossOrigin &&
                      (r ? (I.crossOrigin = r) : e.removeAttribute("crossorigin"));
                  };
                e.complete && 0 !== e.naturalWidth ? o() : e.addEventListener("load", o);
              }
              if (
                (("audio" === M || "video" === M) &&
                  ((I.rr_mediaState = e.paused ? "paused" : "played"),
                  (I.rr_mediaCurrentTime = e.currentTime)),
                !g &&
                  (e.scrollLeft && (I.rr_scrollLeft = e.scrollLeft),
                  e.scrollTop && (I.rr_scrollTop = e.scrollTop)),
                E)
              ) {
                let { width: t, height: r } = e.getBoundingClientRect();
                I = { class: I.class, rr_width: `${t}px`, rr_height: `${r}px` };
              }
              "iframe" !== M || y(I.src) || (E || eo(e) || (I.rr_src = I.src), delete I.src);
              try {
                customElements.get(M) && (r = !0);
              } catch (e) {}
              return {
                type: j.Element,
                tagName: M,
                attributes: I,
                childNodes: [],
                isSVG: !!("svg" === e.tagName || e.ownerSVGElement) || void 0,
                needBlock: E,
                rootId: S,
                isCustom: r,
              };
            })(e, {
              doc: r,
              blockClass: o,
              blockSelector: a,
              unblockSelector: l,
              inlineStylesheet: m,
              maskAttributeFn: u,
              maskInputOptions: y,
              maskInputFn: S,
              dataURLOptions: v,
              inlineImages: _,
              recordCanvas: w,
              keepIframeSrcFn: b,
              newlyAddedElement: k,
              rootId: M,
              maskTextClass: d,
              unmaskTextClass: h,
              maskTextSelector: p,
              unmaskTextSelector: f,
              ignoreCSSAttributes: E,
            });
          case e.TEXT_NODE:
            return (function (e, t) {
              let {
                  maskAllText: r,
                  maskTextClass: n,
                  unmaskTextClass: i,
                  maskTextSelector: s,
                  unmaskTextSelector: o,
                  maskTextFn: a,
                  maskInputOptions: l,
                  maskInputFn: c,
                  rootId: u,
                } = t,
                d = e.parentNode && e.parentNode.tagName,
                h = e.textContent,
                p = "STYLE" === d || void 0,
                f = "SCRIPT" === d || void 0,
                m = "TEXTAREA" === d || void 0;
              if (p && h) {
                try {
                  e.nextSibling ||
                    e.previousSibling ||
                    (e.parentNode.sheet?.cssRules && (h = q(e.parentNode.sheet)));
                } catch (t) {
                  console.warn(`Cannot get CSS styles from text's parentNode. Error: ${t}`, e);
                }
                h = ef(h, ev(t.doc));
              }
              f && (h = "SCRIPT_PLACEHOLDER");
              let y = eE(e, n, s, i, o, r);
              return (
                p ||
                  f ||
                  m ||
                  !h ||
                  !y ||
                  (h = a ? a(h, e.parentElement) : h.replace(/[\S]/g, "*")),
                m &&
                  h &&
                  (l.textarea || y) &&
                  (h = c ? c(h, e.parentNode) : h.replace(/[\S]/g, "*")),
                "OPTION" === d &&
                  h &&
                  (h = G({
                    isMasked: eE(e, n, s, i, o, J({ type: null, tagName: d, maskInputOptions: l })),
                    element: e,
                    value: h,
                    maskInputFn: c,
                  })),
                { type: j.Text, textContent: h || "", isStyle: p, rootId: u }
              );
            })(e, {
              doc: r,
              maskAllText: c,
              maskTextClass: d,
              unmaskTextClass: h,
              maskTextSelector: p,
              unmaskTextSelector: f,
              maskTextFn: g,
              maskInputOptions: y,
              maskInputFn: S,
              rootId: M,
            });
          case e.CDATA_SECTION_NODE:
            return { type: j.CDATA, textContent: "", rootId: M };
          case e.COMMENT_NODE:
            return { type: j.Comment, textContent: e.textContent || "", rootId: M };
          default:
            return !1;
        }
      })(e, {
        doc: s,
        mirror: o,
        blockClass: a,
        blockSelector: l,
        maskAllText: u,
        unblockSelector: c,
        maskTextClass: d,
        unmaskTextClass: h,
        maskTextSelector: p,
        unmaskTextSelector: f,
        inlineStylesheet: y,
        maskInputOptions: g,
        maskAttributeFn: S,
        maskTextFn: v,
        maskInputFn: _,
        dataURLOptions: b,
        inlineImages: k,
        recordCanvas: E,
        keepIframeSrcFn: O,
        newlyAddedElement: D,
        ignoreCSSAttributes: N,
      });
    if (!L) return (console.warn(e, "not serialized"), null);
    r = o.hasNode(e)
      ? o.getId(e)
      : !(function (e, t) {
            if (t.comment && e.type === j.Comment) return !0;
            if (e.type === j.Element) {
              if (
                t.script &&
                ("script" === e.tagName ||
                  ("link" === e.tagName &&
                    ("preload" === e.attributes.rel || "modulepreload" === e.attributes.rel)) ||
                  ("link" === e.tagName &&
                    "prefetch" === e.attributes.rel &&
                    "string" == typeof e.attributes.href &&
                    "js" === et(e.attributes.href)))
              )
                return !0;
              else if (
                t.headFavicon &&
                (("link" === e.tagName && "shortcut icon" === e.attributes.rel) ||
                  ("meta" === e.tagName &&
                    (eM(e.attributes.name).match(/^msapplication-tile(image|color)$/) ||
                      "application-name" === eM(e.attributes.name) ||
                      "icon" === eM(e.attributes.rel) ||
                      "apple-touch-icon" === eM(e.attributes.rel) ||
                      "shortcut icon" === eM(e.attributes.rel))))
              )
                return !0;
              else if ("meta" === e.tagName) {
                if (t.headMetaDescKeywords && eM(e.attributes.name).match(/^description|keywords$/))
                  return !0;
                else if (
                  t.headMetaSocial &&
                  (eM(e.attributes.property).match(/^(og|twitter|fb):/) ||
                    eM(e.attributes.name).match(/^(og|twitter):/) ||
                    "pinterest" === eM(e.attributes.name))
                )
                  return !0;
                else if (
                  t.headMetaRobots &&
                  ("robots" === eM(e.attributes.name) ||
                    "googlebot" === eM(e.attributes.name) ||
                    "bingbot" === eM(e.attributes.name))
                )
                  return !0;
                else if (t.headMetaHttpEquiv && void 0 !== e.attributes["http-equiv"]) return !0;
                else if (
                  t.headMetaAuthorship &&
                  ("author" === eM(e.attributes.name) ||
                    "generator" === eM(e.attributes.name) ||
                    "framework" === eM(e.attributes.name) ||
                    "publisher" === eM(e.attributes.name) ||
                    "progid" === eM(e.attributes.name) ||
                    eM(e.attributes.property).match(/^article:/) ||
                    eM(e.attributes.property).match(/^product:/))
                )
                  return !0;
                else if (
                  t.headMetaVerification &&
                  ("google-site-verification" === eM(e.attributes.name) ||
                    "yandex-verification" === eM(e.attributes.name) ||
                    "csrf-token" === eM(e.attributes.name) ||
                    "p:domain_verify" === eM(e.attributes.name) ||
                    "verify-v1" === eM(e.attributes.name) ||
                    "verification" === eM(e.attributes.name) ||
                    "shopify-checkout-api-token" === eM(e.attributes.name))
                )
                  return !0;
              }
            }
            return !1;
          })(L, w) &&
          (A || L.type !== j.Text || L.isStyle || L.textContent.replace(/^\s+|\s+$/gm, "").length)
        ? ec()
        : -2;
    let P = Object.assign(L, { id: r });
    if ((o.add(e, P), -2 === r)) return null;
    M && M(e);
    let F = !m;
    if (P.type === j.Element) {
      F = F && !P.needBlock;
      let t = e.shadowRoot;
      t && $(t) && (P.isShadowHost = !0);
    }
    if ((P.type === j.Document || P.type === j.Element) && F) {
      w.headWhitespace && P.type === j.Element && "head" === P.tagName && (A = !1);
      let t = {
        doc: s,
        mirror: o,
        blockClass: a,
        blockSelector: l,
        maskAllText: u,
        unblockSelector: c,
        maskTextClass: d,
        unmaskTextClass: h,
        maskTextSelector: p,
        unmaskTextSelector: f,
        skipChild: m,
        inlineStylesheet: y,
        maskInputOptions: g,
        maskAttributeFn: S,
        maskTextFn: v,
        maskInputFn: _,
        slimDOMOptions: w,
        dataURLOptions: b,
        inlineImages: k,
        recordCanvas: E,
        preserveWhiteSpace: A,
        onSerialize: M,
        onIframeLoad: I,
        iframeLoadTimeout: C,
        onBlockedImageLoad: R,
        onStylesheetLoad: T,
        stylesheetLoadTimeout: x,
        keepIframeSrcFn: O,
        ignoreCSSAttributes: N,
      };
      for (let r of e.childNodes ? Array.from(e.childNodes) : []) {
        let e = eI(r, t);
        e && P.childNodes.push(e);
      }
      if (e.nodeType === e.ELEMENT_NODE && e.shadowRoot)
        for (let r of Array.from(e.shadowRoot.childNodes)) {
          let n = eI(r, t);
          n && ($(e.shadowRoot) && (n.isShadow = !0), P.childNodes.push(n));
        }
    }
    if (
      (e.parentNode && H(e.parentNode) && $(e.parentNode) && (P.isShadow = !0),
      P.type !== j.Element ||
        "iframe" !== P.tagName ||
        P.needBlock ||
        (function (e, t, r) {
          let n,
            i = e.contentWindow;
          if (!i) return;
          let s = !1;
          try {
            n = i.document.readyState;
          } catch (e) {
            return;
          }
          if ("complete" !== n) {
            let n = ei(() => {
              s || (t(), (s = !0));
            }, r);
            e.addEventListener("load", () => {
              (es(n), (s = !0), t());
            });
            return;
          }
          let o = "about:blank";
          if (i.location.href !== o || e.src === o || "" === e.src)
            return (ei(t, 0), e.addEventListener("load", t));
          e.addEventListener("load", t);
        })(
          e,
          () => {
            let t = eo(e);
            if (t && I) {
              let r = eI(t, {
                doc: t,
                mirror: o,
                blockClass: a,
                blockSelector: l,
                unblockSelector: c,
                maskAllText: u,
                maskTextClass: d,
                unmaskTextClass: h,
                maskTextSelector: p,
                unmaskTextSelector: f,
                skipChild: !1,
                inlineStylesheet: y,
                maskInputOptions: g,
                maskAttributeFn: S,
                maskTextFn: v,
                maskInputFn: _,
                slimDOMOptions: w,
                dataURLOptions: b,
                inlineImages: k,
                recordCanvas: E,
                preserveWhiteSpace: A,
                onSerialize: M,
                onIframeLoad: I,
                iframeLoadTimeout: C,
                onStylesheetLoad: T,
                stylesheetLoadTimeout: x,
                keepIframeSrcFn: O,
                ignoreCSSAttributes: N,
              });
              r && I(e, r);
            }
          },
          C,
        ),
      P.type === j.Element && "img" === P.tagName && !e.complete && P.needBlock)
    ) {
      let t = () => {
        if (e.isConnected && !e.complete && R)
          try {
            let t = e.getBoundingClientRect();
            t.width > 0 && t.height > 0 && R(e, P, t);
          } catch (e) {}
        e.removeEventListener("load", t);
      };
      e.isConnected && e.addEventListener("load", t);
    }
    return (
      P.type === j.Element &&
        "link" === P.tagName &&
        "string" == typeof P.attributes.rel &&
        ("stylesheet" === P.attributes.rel ||
          ("preload" === P.attributes.rel &&
            "string" == typeof P.attributes.href &&
            "css" === et(P.attributes.href))) &&
        (function (e, t, r) {
          let n,
            i = !1;
          try {
            n = e.sheet;
          } catch (e) {
            return;
          }
          if (n) return;
          let s = ei(() => {
            i || (t(), (i = !0));
          }, r);
          e.addEventListener("load", () => {
            (es(s), (i = !0), t());
          });
        })(
          e,
          () => {
            if (T) {
              let t = eI(e, {
                doc: s,
                mirror: o,
                blockClass: a,
                blockSelector: l,
                unblockSelector: c,
                maskAllText: u,
                maskTextClass: d,
                unmaskTextClass: h,
                maskTextSelector: p,
                unmaskTextSelector: f,
                skipChild: !1,
                inlineStylesheet: y,
                maskInputOptions: g,
                maskAttributeFn: S,
                maskTextFn: v,
                maskInputFn: _,
                slimDOMOptions: w,
                dataURLOptions: b,
                inlineImages: k,
                recordCanvas: E,
                preserveWhiteSpace: A,
                onSerialize: M,
                onIframeLoad: I,
                iframeLoadTimeout: C,
                onStylesheetLoad: T,
                stylesheetLoadTimeout: x,
                keepIframeSrcFn: O,
                ignoreCSSAttributes: N,
              });
              t && T(e, t);
            }
          },
          x,
        ),
      P.type === j.Element && delete P.needBlock,
      P
    );
  }
  function eC(e, t, r = document) {
    let n = { capture: !0, passive: !0 };
    return (r.addEventListener(e, t, n), () => r.removeEventListener(e, t, n));
  }
  let eR =
      "Please stop import mirror directly. Instead of that,\r\nnow you can use replayer.getMirror() to access the mirror instance of a replayer,\r\nor you can use record.mirror to access the mirror instance during recording.",
    eT = {
      map: {},
      getId: () => (console.error(eR), -1),
      getNode: () => (console.error(eR), null),
      removeNodeFromMap() {
        console.error(eR);
      },
      has: () => (console.error(eR), !1),
      reset() {
        console.error(eR);
      },
    };
  function ex(e, t, r = {}) {
    let n = null,
      i = 0;
    return function (...s) {
      let o = Date.now();
      i || !1 !== r.leading || (i = o);
      let a = t - (o - i),
        l = this;
      a <= 0 || a > t
        ? (n &&
            ((function (...e) {
              eV("clearTimeout")(...e);
            })(n),
            (n = null)),
          (i = o),
          e.apply(l, s))
        : n ||
          !1 === r.trailing ||
          (n = eJ(() => {
            ((i = !1 === r.leading ? 0 : Date.now()), (n = null), e.apply(l, s));
          }, a));
    };
  }
  function eO(e, t, r) {
    try {
      if (!(t in e)) return () => {};
      let n = e[t],
        i = r(n);
      return (
        "function" == typeof i &&
          ((i.prototype = i.prototype || {}),
          Object.defineProperties(i, { __rrweb_original__: { enumerable: !1, value: n } })),
        (e[t] = i),
        () => {
          e[t] = n;
        }
      );
    } catch {
      return () => {};
    }
  }
  "undefined" != typeof window &&
    window.Proxy &&
    window.Reflect &&
    (eT = new Proxy(eT, {
      get: (e, t, r) => ("map" === t && console.error(eR), Reflect.get(e, t, r)),
    }));
  let eD = Date.now;
  function eN(e) {
    let t = e.document;
    return {
      left: t.scrollingElement
        ? t.scrollingElement.scrollLeft
        : void 0 !== e.pageXOffset
          ? e.pageXOffset
          : t?.documentElement.scrollLeft ||
            t?.body?.parentElement?.scrollLeft ||
            t?.body?.scrollLeft ||
            0,
      top: t.scrollingElement
        ? t.scrollingElement.scrollTop
        : void 0 !== e.pageYOffset
          ? e.pageYOffset
          : t?.documentElement.scrollTop ||
            t?.body?.parentElement?.scrollTop ||
            t?.body?.scrollTop ||
            0,
    };
  }
  function eA() {
    return (
      window.innerHeight ||
      (document.documentElement && document.documentElement.clientHeight) ||
      (document.body && document.body.clientHeight)
    );
  }
  function eL() {
    return (
      window.innerWidth ||
      (document.documentElement && document.documentElement.clientWidth) ||
      (document.body && document.body.clientWidth)
    );
  }
  function eP(e) {
    if (!e) return null;
    try {
      return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
    } catch (e) {
      return null;
    }
  }
  function eF(e, t, r, n, i) {
    if (!e) return !1;
    let s = eP(e);
    if (!s) return !1;
    let o = ek(t, r);
    if (!i) {
      let e = n && s.matches(n);
      return o(s) && !e;
    }
    let a = eb(s, o),
      l = -1;
    return !(a < 0) && (n && (l = eb(s, ek(null, n))), (a > -1 && l < 0) || a < l);
  }
  function eB(e, t) {
    return -2 === t.getId(e);
  }
  function eU(e) {
    return !!e.changedTouches;
  }
  function ez(e, t) {
    return !!("IFRAME" === e.nodeName && t.getMeta(e));
  }
  function eW(e, t) {
    return !!(
      "LINK" === e.nodeName &&
      e.nodeType === e.ELEMENT_NODE &&
      e.getAttribute &&
      "stylesheet" === e.getAttribute("rel") &&
      t.getMeta(e)
    );
  }
  function ej(e) {
    return !!e?.shadowRoot;
  }
  /[1-9][0-9]{12}/.test(Date.now().toString()) || (eD = () => new Date().getTime());
  class eH {
    constructor() {
      ((this.id = 1), (this.styleIDMap = new WeakMap()), (this.idStyleMap = new Map()));
    }
    getId(e) {
      return this.styleIDMap.get(e) ?? -1;
    }
    has(e) {
      return this.styleIDMap.has(e);
    }
    add(e, t) {
      let r;
      return this.has(e)
        ? this.getId(e)
        : ((r = void 0 === t ? this.id++ : t),
          this.styleIDMap.set(e, r),
          this.idStyleMap.set(r, e),
          r);
    }
    getStyle(e) {
      return this.idStyleMap.get(e) || null;
    }
    reset() {
      ((this.styleIDMap = new WeakMap()), (this.idStyleMap = new Map()), (this.id = 1));
    }
    generateId() {
      return this.id++;
    }
  }
  function e$(e) {
    let t = null;
    return (
      e.getRootNode?.()?.nodeType === Node.DOCUMENT_FRAGMENT_NODE &&
        e.getRootNode().host &&
        (t = e.getRootNode().host),
      t
    );
  }
  function eq(e) {
    let t = e.ownerDocument;
    return (
      !!t &&
      (t.contains(e) ||
        (function (e) {
          let t = e.ownerDocument;
          if (!t) return !1;
          let r = (function (e) {
            let t,
              r = e;
            for (; (t = e$(r)); ) r = t;
            return r;
          })(e);
          return t.contains(r);
        })(e))
    );
  }
  let eK = {};
  function eV(e) {
    let t = eK[e];
    if (t) return t;
    let r = window.document,
      n = window[e];
    if (r && "function" == typeof r.createElement)
      try {
        let t = r.createElement("iframe");
        ((t.hidden = !0), r.head.appendChild(t));
        let i = t.contentWindow;
        (i && i[e] && (n = i[e]), r.head.removeChild(t));
      } catch (e) {}
    return (eK[e] = n.bind(window));
  }
  function eJ(...e) {
    return eV("setTimeout")(...e);
  }
  var eG = ((e) => (
      (e[(e.DomContentLoaded = 0)] = "DomContentLoaded"),
      (e[(e.Load = 1)] = "Load"),
      (e[(e.FullSnapshot = 2)] = "FullSnapshot"),
      (e[(e.IncrementalSnapshot = 3)] = "IncrementalSnapshot"),
      (e[(e.Meta = 4)] = "Meta"),
      (e[(e.Custom = 5)] = "Custom"),
      (e[(e.Plugin = 6)] = "Plugin"),
      e
    ))(eG || {}),
    eY = ((e) => (
      (e[(e.Mutation = 0)] = "Mutation"),
      (e[(e.MouseMove = 1)] = "MouseMove"),
      (e[(e.MouseInteraction = 2)] = "MouseInteraction"),
      (e[(e.Scroll = 3)] = "Scroll"),
      (e[(e.ViewportResize = 4)] = "ViewportResize"),
      (e[(e.Input = 5)] = "Input"),
      (e[(e.TouchMove = 6)] = "TouchMove"),
      (e[(e.MediaInteraction = 7)] = "MediaInteraction"),
      (e[(e.StyleSheetRule = 8)] = "StyleSheetRule"),
      (e[(e.CanvasMutation = 9)] = "CanvasMutation"),
      (e[(e.Font = 10)] = "Font"),
      (e[(e.Log = 11)] = "Log"),
      (e[(e.Drag = 12)] = "Drag"),
      (e[(e.StyleDeclaration = 13)] = "StyleDeclaration"),
      (e[(e.Selection = 14)] = "Selection"),
      (e[(e.AdoptedStyleSheet = 15)] = "AdoptedStyleSheet"),
      (e[(e.CustomElement = 16)] = "CustomElement"),
      e
    ))(eY || {}),
    eX = ((e) => (
      (e[(e.MouseUp = 0)] = "MouseUp"),
      (e[(e.MouseDown = 1)] = "MouseDown"),
      (e[(e.Click = 2)] = "Click"),
      (e[(e.ContextMenu = 3)] = "ContextMenu"),
      (e[(e.DblClick = 4)] = "DblClick"),
      (e[(e.Focus = 5)] = "Focus"),
      (e[(e.Blur = 6)] = "Blur"),
      (e[(e.TouchStart = 7)] = "TouchStart"),
      (e[(e.TouchMove_Departed = 8)] = "TouchMove_Departed"),
      (e[(e.TouchEnd = 9)] = "TouchEnd"),
      (e[(e.TouchCancel = 10)] = "TouchCancel"),
      e
    ))(eX || {}),
    eQ = ((e) => (
      (e[(e.Mouse = 0)] = "Mouse"),
      (e[(e.Pen = 1)] = "Pen"),
      (e[(e.Touch = 2)] = "Touch"),
      e
    ))(eQ || {}),
    eZ = ((e) => (
      (e[(e.Play = 0)] = "Play"),
      (e[(e.Pause = 1)] = "Pause"),
      (e[(e.Seeked = 2)] = "Seeked"),
      (e[(e.VolumeChange = 3)] = "VolumeChange"),
      (e[(e.RateChange = 4)] = "RateChange"),
      e
    ))(eZ || {});
  function e0(e) {
    try {
      return e.contentDocument;
    } catch (e) {}
  }
  class e1 {
    constructor() {
      ((this.length = 0), (this.head = null), (this.tail = null));
    }
    get(e) {
      if (e >= this.length) throw Error("Position outside of list range");
      let t = this.head;
      for (let r = 0; r < e; r++) t = t?.next || null;
      return t;
    }
    addNode(e) {
      let t = { value: e, previous: null, next: null };
      if (((e.__ln = t), e.previousSibling && "__ln" in e.previousSibling)) {
        let r = e.previousSibling.__ln.next;
        ((t.next = r),
          (t.previous = e.previousSibling.__ln),
          (e.previousSibling.__ln.next = t),
          r && (r.previous = t));
      } else if (e.nextSibling && "__ln" in e.nextSibling && e.nextSibling.__ln.previous) {
        let r = e.nextSibling.__ln.previous;
        ((t.previous = r),
          (t.next = e.nextSibling.__ln),
          (e.nextSibling.__ln.previous = t),
          r && (r.next = t));
      } else (this.head && (this.head.previous = t), (t.next = this.head), (this.head = t));
      (null === t.next && (this.tail = t), this.length++);
    }
    removeNode(e) {
      let t = e.__ln;
      this.head &&
        (t.previous
          ? ((t.previous.next = t.next),
            t.next ? (t.next.previous = t.previous) : (this.tail = t.previous))
          : ((this.head = t.next), this.head ? (this.head.previous = null) : (this.tail = null)),
        e.__ln && delete e.__ln,
        this.length--);
    }
  }
  let e2 = (e, t) => `${e}@${t}`;
  class e3 {
    constructor() {
      ((this.frozen = !1),
        (this.locked = !1),
        (this.texts = []),
        (this.attributes = []),
        (this.attributeMap = new WeakMap()),
        (this.removes = []),
        (this.mapRemoves = []),
        (this.movedMap = {}),
        (this.addedSet = new Set()),
        (this.movedSet = new Set()),
        (this.droppedSet = new Set()),
        (this.processMutations = (e) => {
          (e.forEach(this.processMutation), this.emit());
        }),
        (this.emit = () => {
          if (this.frozen || this.locked) return;
          let e = [],
            t = new Set(),
            r = new e1(),
            n = (e) => {
              let t = e,
                r = -2;
              for (; -2 === r; ) r = (t = t && t.nextSibling) && this.mirror.getId(t);
              return r;
            },
            i = (i) => {
              if (!i.parentNode || !eq(i)) return;
              let s = H(i.parentNode) ? this.mirror.getId(e$(i)) : this.mirror.getId(i.parentNode),
                o = n(i);
              if (-1 === s || -1 === o) return r.addNode(i);
              let a = eI(i, {
                doc: this.doc,
                mirror: this.mirror,
                blockClass: this.blockClass,
                blockSelector: this.blockSelector,
                maskAllText: this.maskAllText,
                unblockSelector: this.unblockSelector,
                maskTextClass: this.maskTextClass,
                unmaskTextClass: this.unmaskTextClass,
                maskTextSelector: this.maskTextSelector,
                unmaskTextSelector: this.unmaskTextSelector,
                skipChild: !0,
                newlyAddedElement: !0,
                inlineStylesheet: this.inlineStylesheet,
                maskInputOptions: this.maskInputOptions,
                maskAttributeFn: this.maskAttributeFn,
                maskTextFn: this.maskTextFn,
                maskInputFn: this.maskInputFn,
                slimDOMOptions: this.slimDOMOptions,
                dataURLOptions: this.dataURLOptions,
                recordCanvas: this.recordCanvas,
                inlineImages: this.inlineImages,
                onSerialize: (e) => {
                  (ez(e, this.mirror) &&
                    !eF(e, this.blockClass, this.blockSelector, this.unblockSelector, !1) &&
                    this.iframeManager.addIframe(e),
                    eW(e, this.mirror) && this.stylesheetManager.trackLinkElement(e),
                    ej(i) && this.shadowDomManager.addShadowRoot(i.shadowRoot, this.doc));
                },
                onIframeLoad: (e, t) => {
                  eF(e, this.blockClass, this.blockSelector, this.unblockSelector, !1) ||
                    (this.iframeManager.attachIframe(e, t),
                    e.contentWindow && this.canvasManager.addWindow(e.contentWindow),
                    this.shadowDomManager.observeAttachShadow(e));
                },
                onStylesheetLoad: (e, t) => {
                  this.stylesheetManager.attachLinkElement(e, t);
                },
                onBlockedImageLoad: (e, t, { width: r, height: n }) => {
                  this.mutationCb({
                    adds: [],
                    removes: [],
                    texts: [],
                    attributes: [
                      { id: t.id, attributes: { style: { width: `${r}px`, height: `${n}px` } } },
                    ],
                  });
                },
                ignoreCSSAttributes: this.ignoreCSSAttributes,
              });
              a && (e.push({ parentId: s, nextId: o, node: a }), t.add(a.id));
            };
          for (; this.mapRemoves.length; ) this.mirror.removeNodeFromMap(this.mapRemoves.shift());
          for (let e of this.movedSet)
            (!e8(this.removes, e, this.mirror) || this.movedSet.has(e.parentNode)) && i(e);
          for (let e of this.addedSet)
            e6(this.droppedSet, e) || e8(this.removes, e, this.mirror)
              ? e6(this.movedSet, e)
                ? i(e)
                : this.droppedSet.add(e)
              : i(e);
          let s = null;
          for (; r.length; ) {
            let e = null;
            if (s) {
              let t = this.mirror.getId(s.value.parentNode),
                r = n(s.value);
              -1 !== t && -1 !== r && (e = s);
            }
            if (!e) {
              let t = r.tail;
              for (; t; ) {
                let r = t;
                if (((t = t.previous), r)) {
                  let t = this.mirror.getId(r.value.parentNode);
                  if (-1 === n(r.value)) continue;
                  if (-1 !== t) {
                    e = r;
                    break;
                  }
                  {
                    let t = r.value;
                    if (t.parentNode && t.parentNode.nodeType === Node.DOCUMENT_FRAGMENT_NODE) {
                      let n = t.parentNode.host;
                      if (-1 !== this.mirror.getId(n)) {
                        e = r;
                        break;
                      }
                    }
                  }
                }
              }
            }
            if (!e) {
              for (; r.head; ) r.removeNode(r.head.value);
              break;
            }
            ((s = e.previous), r.removeNode(e.value), i(e.value));
          }
          let o = {
            texts: this.texts
              .map((e) => ({ id: this.mirror.getId(e.node), value: e.value }))
              .filter((e) => !t.has(e.id))
              .filter((e) => this.mirror.has(e.id)),
            attributes: this.attributes
              .map((e) => {
                let { attributes: t } = e;
                if ("string" == typeof t.style) {
                  let r = JSON.stringify(e.styleDiff),
                    n = JSON.stringify(e._unchangedStyles);
                  r.length < t.style.length &&
                    (r + n).split("var(").length === t.style.split("var(").length &&
                    (t.style = e.styleDiff);
                }
                return { id: this.mirror.getId(e.node), attributes: t };
              })
              .filter((e) => !t.has(e.id))
              .filter((e) => this.mirror.has(e.id)),
            removes: this.removes,
            adds: e,
          };
          (o.texts.length || o.attributes.length || o.removes.length || o.adds.length) &&
            ((this.texts = []),
            (this.attributes = []),
            (this.attributeMap = new WeakMap()),
            (this.removes = []),
            (this.addedSet = new Set()),
            (this.movedSet = new Set()),
            (this.droppedSet = new Set()),
            (this.movedMap = {}),
            this.mutationCb(o));
        }),
        (this.processMutation = (e) => {
          if (!eB(e.target, this.mirror))
            switch (e.type) {
              case "characterData": {
                let t = e.target.textContent;
                eF(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) ||
                  t === e.oldValue ||
                  this.texts.push({
                    value:
                      eE(
                        e.target,
                        this.maskTextClass,
                        this.maskTextSelector,
                        this.unmaskTextClass,
                        this.unmaskTextSelector,
                        this.maskAllText,
                      ) && t
                        ? this.maskTextFn
                          ? this.maskTextFn(t, eP(e.target))
                          : t.replace(/[\S]/g, "*")
                        : t,
                    node: e.target,
                  });
                break;
              }
              case "attributes": {
                let t = e.target,
                  r = e.attributeName,
                  n = e.target.getAttribute(r);
                if ("value" === r) {
                  let r = Z(t),
                    i = t.tagName;
                  n = ee(t, i, r);
                  let s = J({ maskInputOptions: this.maskInputOptions, tagName: i, type: r });
                  n = G({
                    isMasked: eE(
                      e.target,
                      this.maskTextClass,
                      this.maskTextSelector,
                      this.unmaskTextClass,
                      this.unmaskTextSelector,
                      s,
                    ),
                    element: t,
                    value: n,
                    maskInputFn: this.maskInputFn,
                  });
                }
                if (
                  eF(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) ||
                  n === e.oldValue
                )
                  return;
                let i = this.attributeMap.get(e.target);
                if ("IFRAME" === t.tagName && "src" === r && !this.keepIframeSrcFn(n)) {
                  if (e0(t)) return;
                  r = "rr_src";
                }
                if (
                  (i ||
                    ((i = { node: e.target, attributes: {}, styleDiff: {}, _unchangedStyles: {} }),
                    this.attributes.push(i),
                    this.attributeMap.set(e.target, i)),
                  "type" === r &&
                    "INPUT" === t.tagName &&
                    "password" === (e.oldValue || "").toLowerCase() &&
                    t.setAttribute("data-rr-is-password", "true"),
                  !ew(t.tagName, r) &&
                    ((i.attributes[r] = e_(
                      this.doc,
                      Y(t.tagName),
                      Y(r),
                      n,
                      t,
                      this.maskAttributeFn,
                    )),
                    "style" === r))
                ) {
                  if (!this.unattachedDoc)
                    try {
                      this.unattachedDoc = document.implementation.createHTMLDocument();
                    } catch (e) {
                      this.unattachedDoc = this.doc;
                    }
                  let r = this.unattachedDoc.createElement("span");
                  for (let n of (e.oldValue && r.setAttribute("style", e.oldValue),
                  Array.from(t.style))) {
                    let e = t.style.getPropertyValue(n),
                      s = t.style.getPropertyPriority(n);
                    e !== r.style.getPropertyValue(n) || s !== r.style.getPropertyPriority(n)
                      ? "" === s
                        ? (i.styleDiff[n] = e)
                        : (i.styleDiff[n] = [e, s])
                      : (i._unchangedStyles[n] = [e, s]);
                  }
                  for (let e of Array.from(r.style))
                    "" === t.style.getPropertyValue(e) && (i.styleDiff[e] = !1);
                }
                break;
              }
              case "childList":
                if (eF(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !0))
                  return;
                (e.addedNodes.forEach((t) => this.genAdds(t, e.target)),
                  e.removedNodes.forEach((t) => {
                    let r = this.mirror.getId(t),
                      n = H(e.target)
                        ? this.mirror.getId(e.target.host)
                        : this.mirror.getId(e.target);
                    eF(e.target, this.blockClass, this.blockSelector, this.unblockSelector, !1) ||
                      eB(t, this.mirror) ||
                      -1 === this.mirror.getId(t) ||
                      (this.addedSet.has(t)
                        ? (e5(this.addedSet, t), this.droppedSet.add(t))
                        : (this.addedSet.has(e.target) && -1 === r) ||
                          (function e(t, r) {
                            if (H(t)) return !1;
                            let n = r.getId(t);
                            return (
                              !r.has(n) ||
                              ((!t.parentNode || t.parentNode.nodeType !== t.DOCUMENT_NODE) &&
                                (!t.parentNode || e(t.parentNode, r)))
                            );
                          })(e.target, this.mirror) ||
                          (this.movedSet.has(t) && this.movedMap[e2(r, n)]
                            ? e5(this.movedSet, t)
                            : this.removes.push({
                                parentId: n,
                                id: r,
                                isShadow: !!(H(e.target) && $(e.target)) || void 0,
                              })),
                      this.mapRemoves.push(t));
                  }));
            }
        }),
        (this.genAdds = (e, t) => {
          if (
            !this.processedNodeManager.inOtherBuffer(e, this) &&
            !(this.addedSet.has(e) || this.movedSet.has(e))
          ) {
            if (this.mirror.hasNode(e)) {
              if (eB(e, this.mirror)) return;
              this.movedSet.add(e);
              let r = null;
              (t && this.mirror.hasNode(t) && (r = this.mirror.getId(t)),
                r && -1 !== r && (this.movedMap[e2(this.mirror.getId(e), r)] = !0));
            } else (this.addedSet.add(e), this.droppedSet.delete(e));
            !eF(e, this.blockClass, this.blockSelector, this.unblockSelector, !1) &&
              (e.childNodes && e.childNodes.forEach((e) => this.genAdds(e)),
              ej(e) &&
                e.shadowRoot.childNodes.forEach((t) => {
                  (this.processedNodeManager.add(t, this), this.genAdds(t, e));
                }));
          }
        }));
    }
    init(e) {
      [
        "mutationCb",
        "blockClass",
        "blockSelector",
        "unblockSelector",
        "maskAllText",
        "maskTextClass",
        "unmaskTextClass",
        "maskTextSelector",
        "unmaskTextSelector",
        "inlineStylesheet",
        "maskInputOptions",
        "maskAttributeFn",
        "maskTextFn",
        "maskInputFn",
        "keepIframeSrcFn",
        "recordCanvas",
        "inlineImages",
        "slimDOMOptions",
        "dataURLOptions",
        "doc",
        "mirror",
        "iframeManager",
        "stylesheetManager",
        "shadowDomManager",
        "canvasManager",
        "processedNodeManager",
        "ignoreCSSAttributes",
      ].forEach((t) => {
        this[t] = e[t];
      });
    }
    freeze() {
      ((this.frozen = !0), this.canvasManager.freeze());
    }
    unfreeze() {
      ((this.frozen = !1), this.canvasManager.unfreeze(), this.emit());
    }
    isFrozen() {
      return this.frozen;
    }
    lock() {
      ((this.locked = !0), this.canvasManager.lock());
    }
    unlock() {
      ((this.locked = !1), this.canvasManager.unlock(), this.emit());
    }
    reset() {
      (this.shadowDomManager.reset(), this.canvasManager.reset());
    }
  }
  function e5(e, t) {
    (e.delete(t), t.childNodes?.forEach((t) => e5(e, t)));
  }
  function e8(e, t, r) {
    return (
      0 !== e.length &&
      (function (e, t, r) {
        let n = t.parentNode;
        for (; n; ) {
          let t = r.getId(n);
          if (e.some((e) => e.id === t)) return !0;
          n = n.parentNode;
        }
        return !1;
      })(e, t, r)
    );
  }
  function e6(e, t) {
    return (
      0 !== e.size &&
      (function e(t, r) {
        let { parentNode: n } = r;
        return !!n && (!!t.has(n) || e(t, n));
      })(e, t)
    );
  }
  let e4 = (e) =>
      s
        ? (...t) => {
            try {
              return e(...t);
            } catch (e) {
              if (s && !0 === s(e)) return () => {};
              throw e;
            }
          }
        : e,
    e7 = [];
  function e9(e) {
    try {
      if ("composedPath" in e) {
        let t = e.composedPath();
        if (t.length) return t[0];
      } else if ("path" in e && e.path.length) return e.path[0];
    } catch {}
    return e && e.target;
  }
  function te(e, t) {
    let r = new e3();
    (e7.push(r), r.init(e));
    let n = window.MutationObserver || window.__rrMutationObserver,
      i = window?.Zone?.__symbol__?.("MutationObserver");
    i && window[i] && (n = window[i]);
    let s = new n(
      e4((t) => {
        (e.onMutation && !1 === e.onMutation(t)) || r.processMutations.bind(r)(t);
      }),
    );
    return (
      s.observe(t, {
        attributes: !0,
        attributeOldValue: !0,
        characterData: !0,
        characterDataOldValue: !0,
        childList: !0,
        subtree: !0,
      }),
      s
    );
  }
  function tt({
    scrollCb: e,
    doc: t,
    mirror: r,
    blockClass: n,
    blockSelector: i,
    unblockSelector: s,
    sampling: o,
  }) {
    return eC(
      "scroll",
      e4(
        ex(
          e4((o) => {
            let a = e9(o);
            if (!a || eF(a, n, i, s, !0)) return;
            let l = r.getId(a);
            if (a === t && t.defaultView) {
              let r = eN(t.defaultView);
              e({ id: l, x: r.left, y: r.top });
            } else e({ id: l, x: a.scrollLeft, y: a.scrollTop });
          }),
          o.scroll || 100,
        ),
      ),
      t,
    );
  }
  let tr = ["INPUT", "TEXTAREA", "SELECT"],
    tn = new WeakMap();
  function ti(e) {
    var t = [];
    if (
      (tl("CSSGroupingRule") && e.parentRule instanceof CSSGroupingRule) ||
      (tl("CSSMediaRule") && e.parentRule instanceof CSSMediaRule) ||
      (tl("CSSSupportsRule") && e.parentRule instanceof CSSSupportsRule) ||
      (tl("CSSConditionRule") && e.parentRule instanceof CSSConditionRule)
    ) {
      let r = Array.from(e.parentRule.cssRules).indexOf(e);
      t.unshift(r);
    } else if (e.parentStyleSheet) {
      let r = Array.from(e.parentStyleSheet.cssRules).indexOf(e);
      t.unshift(r);
    }
    return t;
  }
  function ts(e, t, r) {
    let n, i;
    return e
      ? (e.ownerNode ? (n = t.getId(e.ownerNode)) : (i = r.getId(e)), { styleId: i, id: n })
      : {};
  }
  function to({ mirror: e, stylesheetManager: t }, r) {
    let n = null;
    n = "#document" === r.nodeName ? e.getId(r) : e.getId(r.host);
    let i =
        "#document" === r.nodeName
          ? r.defaultView?.Document
          : r.ownerDocument?.defaultView?.ShadowRoot,
      s = i?.prototype
        ? Object.getOwnPropertyDescriptor(i?.prototype, "adoptedStyleSheets")
        : void 0;
    return null !== n && -1 !== n && i && s
      ? (Object.defineProperty(r, "adoptedStyleSheets", {
          configurable: s.configurable,
          enumerable: s.enumerable,
          get() {
            return s.get?.call(this);
          },
          set(e) {
            let r = s.set?.call(this, e);
            if (null !== n && -1 !== n)
              try {
                t.adoptStyleSheets(e, n);
              } catch (e) {}
            return r;
          },
        }),
        e4(() => {
          Object.defineProperty(r, "adoptedStyleSheets", {
            configurable: s.configurable,
            enumerable: s.enumerable,
            get: s.get,
            set: s.set,
          });
        }))
      : () => {};
  }
  function ta(e, t = {}) {
    let r,
      n = e.doc.defaultView;
    if (!n) return () => {};
    e.recordDOM && (r = te(e, e.doc));
    let i = (function ({ mousemoveCb: e, sampling: t, doc: r, mirror: n }) {
        let i;
        if (!1 === t.mousemove) return () => {};
        let s = "number" == typeof t.mousemove ? t.mousemove : 50,
          o = "number" == typeof t.mousemoveCallback ? t.mousemoveCallback : 500,
          a = [],
          l = ex(
            e4((t) => {
              let r = Date.now() - i;
              (e(
                a.map((e) => ((e.timeOffset -= r), e)),
                t,
              ),
                (a = []),
                (i = null));
            }),
            o,
          ),
          c = e4(
            ex(
              e4((e) => {
                let t = e9(e),
                  { clientX: r, clientY: s } = eU(e) ? e.changedTouches[0] : e;
                (i || (i = eD()),
                  a.push({ x: r, y: s, id: n.getId(t), timeOffset: eD() - i }),
                  l(
                    "undefined" != typeof DragEvent && e instanceof DragEvent
                      ? eY.Drag
                      : e instanceof MouseEvent
                        ? eY.MouseMove
                        : eY.TouchMove,
                  ));
              }),
              s,
              { trailing: !1 },
            ),
          ),
          u = [eC("mousemove", c, r), eC("touchmove", c, r), eC("drag", c, r)];
        return e4(() => {
          u.forEach((e) => e());
        });
      })(e),
      s = (function ({
        mouseInteractionCb: e,
        doc: t,
        mirror: r,
        blockClass: n,
        blockSelector: i,
        unblockSelector: s,
        sampling: o,
      }) {
        if (!1 === o.mouseInteraction) return () => {};
        let a =
            !0 === o.mouseInteraction || void 0 === o.mouseInteraction ? {} : o.mouseInteraction,
          l = [],
          c = null;
        return (
          Object.keys(eX)
            .filter((e) => Number.isNaN(Number(e)) && !e.endsWith("_Departed") && !1 !== a[e])
            .forEach((o) => {
              let a = Y(o),
                u = (t) => {
                  let a = e9(t);
                  if (eF(a, n, i, s, !0)) return;
                  let l = null,
                    u = o;
                  if ("pointerType" in t) {
                    switch (t.pointerType) {
                      case "mouse":
                        l = eQ.Mouse;
                        break;
                      case "touch":
                        l = eQ.Touch;
                        break;
                      case "pen":
                        l = eQ.Pen;
                    }
                    l === eQ.Touch
                      ? eX[o] === eX.MouseDown
                        ? (u = "TouchStart")
                        : eX[o] === eX.MouseUp && (u = "TouchEnd")
                      : eQ.Pen;
                  } else eU(t) && (l = eQ.Touch);
                  null !== l
                    ? ((c = l),
                      ((u.startsWith("Touch") && l === eQ.Touch) ||
                        (u.startsWith("Mouse") && l === eQ.Mouse)) &&
                        (l = null))
                    : eX[o] === eX.Click && ((l = c), (c = null));
                  let d = eU(t) ? t.changedTouches[0] : t;
                  if (!d) return;
                  let h = r.getId(a),
                    { clientX: p, clientY: f } = d;
                  e4(e)({ type: eX[u], id: h, x: p, y: f, ...(null !== l && { pointerType: l }) });
                };
              if (window.PointerEvent)
                switch (eX[o]) {
                  case eX.MouseDown:
                  case eX.MouseUp:
                    a = a.replace("mouse", "pointer");
                    break;
                  case eX.TouchStart:
                  case eX.TouchEnd:
                    return;
                }
              l.push(eC(a, u, t));
            }),
          e4(() => {
            l.forEach((e) => e());
          })
        );
      })(e),
      o = tt(e),
      a = (function ({ viewportResizeCb: e }, { win: t }) {
        let r = -1,
          n = -1;
        return eC(
          "resize",
          e4(
            ex(
              e4(() => {
                let t = eA(),
                  i = eL();
                (r !== t || n !== i) &&
                  (e({ width: Number(i), height: Number(t) }), (r = t), (n = i));
              }),
              200,
            ),
          ),
          t,
        );
      })(e, { win: n }),
      l = (function ({
        inputCb: e,
        doc: t,
        mirror: r,
        blockClass: n,
        blockSelector: i,
        unblockSelector: s,
        ignoreClass: o,
        ignoreSelector: a,
        maskInputOptions: l,
        maskInputFn: c,
        sampling: u,
        userTriggeredOnInput: d,
        maskTextClass: h,
        unmaskTextClass: p,
        maskTextSelector: f,
        unmaskTextSelector: m,
      }) {
        function y(e) {
          let r = e9(e),
            u = e.isTrusted,
            y = r && X(r.tagName);
          if (
            ("OPTION" === y && (r = r.parentElement),
            !r || !y || 0 > tr.indexOf(y) || eF(r, n, i, s, !0))
          )
            return;
          let S = r;
          if (S.classList.contains(o) || (a && S.matches(a))) return;
          let v = Z(r),
            _ = ee(S, y, v),
            w = !1,
            b = J({ maskInputOptions: l, tagName: y, type: v }),
            k = eE(r, h, f, p, m, b);
          (("radio" === v || "checkbox" === v) && (w = r.checked),
            (_ = G({ isMasked: k, element: r, value: _, maskInputFn: c })),
            g(r, d ? { text: _, isChecked: w, userTriggered: u } : { text: _, isChecked: w }));
          let E = r.name;
          "radio" === v &&
            E &&
            w &&
            t.querySelectorAll(`input[type="radio"][name="${E}"]`).forEach((e) => {
              if (e !== r) {
                let t = G({ isMasked: k, element: e, value: ee(e, y, v), maskInputFn: c });
                g(
                  e,
                  d ? { text: t, isChecked: !w, userTriggered: !1 } : { text: t, isChecked: !w },
                );
              }
            });
        }
        function g(t, n) {
          let i = tn.get(t);
          if (!i || i.text !== n.text || i.isChecked !== n.isChecked) {
            tn.set(t, n);
            let i = r.getId(t);
            e4(e)({ ...n, id: i });
          }
        }
        let S = ("last" === u.input ? ["change"] : ["input", "change"]).map((e) => eC(e, e4(y), t)),
          v = t.defaultView;
        if (!v)
          return () => {
            S.forEach((e) => e());
          };
        let _ = v.Object.getOwnPropertyDescriptor(v.HTMLInputElement.prototype, "value"),
          w = [
            [v.HTMLInputElement.prototype, "value"],
            [v.HTMLInputElement.prototype, "checked"],
            [v.HTMLSelectElement.prototype, "value"],
            [v.HTMLTextAreaElement.prototype, "value"],
            [v.HTMLSelectElement.prototype, "selectedIndex"],
            [v.HTMLOptionElement.prototype, "selected"],
          ];
        return (
          _ &&
            _.set &&
            S.push(
              ...w.map((e) =>
                (function e(t, r, n, i, s = window) {
                  let o = s.Object.getOwnPropertyDescriptor(t, r);
                  return (
                    s.Object.defineProperty(
                      t,
                      r,
                      i
                        ? n
                        : {
                            set(e) {
                              (eJ(() => {
                                n.set.call(this, e);
                              }, 0),
                                o && o.set && o.set.call(this, e));
                            },
                          },
                    ),
                    () => e(t, r, o || {}, !0)
                  );
                })(
                  e[0],
                  e[1],
                  {
                    set() {
                      e4(y)({ target: this, isTrusted: !1 });
                    },
                  },
                  !1,
                  v,
                ),
              ),
            ),
          e4(() => {
            S.forEach((e) => e());
          })
        );
      })(e),
      c = (function ({
        mediaInteractionCb: e,
        blockClass: t,
        blockSelector: r,
        unblockSelector: n,
        mirror: i,
        sampling: s,
        doc: o,
      }) {
        let a = e4((o) =>
            ex(
              e4((s) => {
                let a = e9(s);
                if (!a || eF(a, t, r, n, !0)) return;
                let { currentTime: l, volume: c, muted: u, playbackRate: d } = a;
                e({
                  type: o,
                  id: i.getId(a),
                  currentTime: l,
                  volume: c,
                  muted: u,
                  playbackRate: d,
                });
              }),
              s.media || 500,
            ),
          ),
          l = [
            eC("play", a(eZ.Play), o),
            eC("pause", a(eZ.Pause), o),
            eC("seeked", a(eZ.Seeked), o),
            eC("volumechange", a(eZ.VolumeChange), o),
            eC("ratechange", a(eZ.RateChange), o),
          ];
        return e4(() => {
          l.forEach((e) => e());
        });
      })(e),
      u = () => {},
      d = () => {},
      h = () => {},
      p = () => {};
    e.recordDOM &&
      ((u = (function ({ styleSheetRuleCb: e, mirror: t, stylesheetManager: r }, { win: n }) {
        let i, s;
        if (!n.CSSStyleSheet || !n.CSSStyleSheet.prototype) return () => {};
        let o = n.CSSStyleSheet.prototype.insertRule;
        n.CSSStyleSheet.prototype.insertRule = new Proxy(o, {
          apply: e4((n, i, s) => {
            let [o, a] = s,
              { id: l, styleId: c } = ts(i, t, r.styleMirror);
            return (
              ((l && -1 !== l) || (c && -1 !== c)) &&
                e({ id: l, styleId: c, adds: [{ rule: o, index: a }] }),
              n.apply(i, s)
            );
          }),
        });
        let a = n.CSSStyleSheet.prototype.deleteRule;
        ((n.CSSStyleSheet.prototype.deleteRule = new Proxy(a, {
          apply: e4((n, i, s) => {
            let [o] = s,
              { id: a, styleId: l } = ts(i, t, r.styleMirror);
            return (
              ((a && -1 !== a) || (l && -1 !== l)) &&
                e({ id: a, styleId: l, removes: [{ index: o }] }),
              n.apply(i, s)
            );
          }),
        })),
          n.CSSStyleSheet.prototype.replace &&
            ((i = n.CSSStyleSheet.prototype.replace),
            (n.CSSStyleSheet.prototype.replace = new Proxy(i, {
              apply: e4((n, i, s) => {
                let [o] = s,
                  { id: a, styleId: l } = ts(i, t, r.styleMirror);
                return (
                  ((a && -1 !== a) || (l && -1 !== l)) && e({ id: a, styleId: l, replace: o }),
                  n.apply(i, s)
                );
              }),
            }))),
          n.CSSStyleSheet.prototype.replaceSync &&
            ((s = n.CSSStyleSheet.prototype.replaceSync),
            (n.CSSStyleSheet.prototype.replaceSync = new Proxy(s, {
              apply: e4((n, i, s) => {
                let [o] = s,
                  { id: a, styleId: l } = ts(i, t, r.styleMirror);
                return (
                  ((a && -1 !== a) || (l && -1 !== l)) && e({ id: a, styleId: l, replaceSync: o }),
                  n.apply(i, s)
                );
              }),
            }))));
        let l = {};
        tc("CSSGroupingRule")
          ? (l.CSSGroupingRule = n.CSSGroupingRule)
          : (tc("CSSMediaRule") && (l.CSSMediaRule = n.CSSMediaRule),
            tc("CSSConditionRule") && (l.CSSConditionRule = n.CSSConditionRule),
            tc("CSSSupportsRule") && (l.CSSSupportsRule = n.CSSSupportsRule));
        let c = {};
        return (
          Object.entries(l).forEach(([n, i]) => {
            ((c[n] = { insertRule: i.prototype.insertRule, deleteRule: i.prototype.deleteRule }),
              (i.prototype.insertRule = new Proxy(c[n].insertRule, {
                apply: e4((n, i, s) => {
                  let [o, a] = s,
                    { id: l, styleId: c } = ts(i.parentStyleSheet, t, r.styleMirror);
                  return (
                    ((l && -1 !== l) || (c && -1 !== c)) &&
                      e({ id: l, styleId: c, adds: [{ rule: o, index: [...ti(i), a || 0] }] }),
                    n.apply(i, s)
                  );
                }),
              })),
              (i.prototype.deleteRule = new Proxy(c[n].deleteRule, {
                apply: e4((n, i, s) => {
                  let [o] = s,
                    { id: a, styleId: l } = ts(i.parentStyleSheet, t, r.styleMirror);
                  return (
                    ((a && -1 !== a) || (l && -1 !== l)) &&
                      e({ id: a, styleId: l, removes: [{ index: [...ti(i), o] }] }),
                    n.apply(i, s)
                  );
                }),
              })));
          }),
          e4(() => {
            ((n.CSSStyleSheet.prototype.insertRule = o),
              (n.CSSStyleSheet.prototype.deleteRule = a),
              i && (n.CSSStyleSheet.prototype.replace = i),
              s && (n.CSSStyleSheet.prototype.replaceSync = s),
              Object.entries(l).forEach(([e, t]) => {
                ((t.prototype.insertRule = c[e].insertRule),
                  (t.prototype.deleteRule = c[e].deleteRule));
              }));
          })
        );
      })(e, { win: n })),
      (d = to(e, e.doc)),
      (h = (function (
        { styleDeclarationCb: e, mirror: t, ignoreCSSAttributes: r, stylesheetManager: n },
        { win: i },
      ) {
        let s = i.CSSStyleDeclaration.prototype.setProperty;
        i.CSSStyleDeclaration.prototype.setProperty = new Proxy(s, {
          apply: e4((i, o, a) => {
            let [l, c, u] = a;
            if (r.has(l)) return s.apply(o, [l, c, u]);
            let { id: d, styleId: h } = ts(o.parentRule?.parentStyleSheet, t, n.styleMirror);
            return (
              ((d && -1 !== d) || (h && -1 !== h)) &&
                e({
                  id: d,
                  styleId: h,
                  set: { property: l, value: c, priority: u },
                  index: ti(o.parentRule),
                }),
              i.apply(o, a)
            );
          }),
        });
        let o = i.CSSStyleDeclaration.prototype.removeProperty;
        return (
          (i.CSSStyleDeclaration.prototype.removeProperty = new Proxy(o, {
            apply: e4((i, s, a) => {
              let [l] = a;
              if (r.has(l)) return o.apply(s, [l]);
              let { id: c, styleId: u } = ts(s.parentRule?.parentStyleSheet, t, n.styleMirror);
              return (
                ((c && -1 !== c) || (u && -1 !== u)) &&
                  e({ id: c, styleId: u, remove: { property: l }, index: ti(s.parentRule) }),
                i.apply(s, a)
              );
            }),
          })),
          e4(() => {
            ((i.CSSStyleDeclaration.prototype.setProperty = s),
              (i.CSSStyleDeclaration.prototype.removeProperty = o));
          })
        );
      })(e, { win: n })),
      e.collectFonts &&
        (p = (function ({ fontCb: e, doc: t }) {
          let r = t.defaultView;
          if (!r) return () => {};
          let n = [],
            i = new WeakMap(),
            s = r.FontFace;
          r.FontFace = function (e, t, r) {
            let n = new s(e, t, r);
            return (
              i.set(n, {
                family: e,
                buffer: "string" != typeof t,
                descriptors: r,
                fontSource:
                  "string" == typeof t ? t : JSON.stringify(Array.from(new Uint8Array(t))),
              }),
              n
            );
          };
          let o = eO(t.fonts, "add", function (t) {
            return function (r) {
              return (
                eJ(
                  e4(() => {
                    let t = i.get(r);
                    t && (e(t), i.delete(r));
                  }),
                  0,
                ),
                t.apply(this, [r])
              );
            };
          });
          return (
            n.push(() => {
              r.FontFace = s;
            }),
            n.push(o),
            e4(() => {
              n.forEach((e) => e());
            })
          );
        })(e)));
    let f = (function (e) {
        let {
            doc: t,
            mirror: r,
            blockClass: n,
            blockSelector: i,
            unblockSelector: s,
            selectionCb: o,
          } = e,
          a = !0,
          l = e4(() => {
            let e = t.getSelection();
            if (!e || (a && e?.isCollapsed)) return;
            a = e.isCollapsed || !1;
            let l = [],
              c = e.rangeCount || 0;
            for (let t = 0; t < c; t++) {
              let {
                startContainer: o,
                startOffset: a,
                endContainer: c,
                endOffset: u,
              } = e.getRangeAt(t);
              eF(o, n, i, s, !0) ||
                eF(c, n, i, s, !0) ||
                l.push({ start: r.getId(o), startOffset: a, end: r.getId(c), endOffset: u });
            }
            o({ ranges: l });
          });
        return (l(), eC("selectionchange", l));
      })(e),
      m = (function ({ doc: e, customElementCb: t }) {
        let r = e.defaultView;
        return r && r.customElements
          ? eO(r.customElements, "define", function (e) {
              return function (r, n, i) {
                try {
                  t({ define: { name: r } });
                } catch (e) {}
                return e.apply(this, [r, n, i]);
              };
            })
          : () => {};
      })(e),
      y = [];
    for (let t of e.plugins) y.push(t.observer(t.callback, n, t.options));
    return e4(() => {
      (e7.forEach((e) => e.reset()),
        r?.disconnect(),
        i(),
        s(),
        o(),
        a(),
        l(),
        c(),
        u(),
        d(),
        h(),
        p(),
        f(),
        m(),
        y.forEach((e) => e()));
    });
  }
  function tl(e) {
    return void 0 !== window[e];
  }
  function tc(e) {
    return !!(
      void 0 !== window[e] &&
      window[e].prototype &&
      "insertRule" in window[e].prototype &&
      "deleteRule" in window[e].prototype
    );
  }
  class tu {
    constructor(e) {
      ((this.generateIdFn = e),
        (this.iframeIdToRemoteIdMap = new WeakMap()),
        (this.iframeRemoteIdToIdMap = new WeakMap()));
    }
    getId(e, t, r, n) {
      let i = r || this.getIdToRemoteIdMap(e),
        s = n || this.getRemoteIdToIdMap(e),
        o = i.get(t);
      return (o || ((o = this.generateIdFn()), i.set(t, o), s.set(o, t)), o);
    }
    getIds(e, t) {
      let r = this.getIdToRemoteIdMap(e),
        n = this.getRemoteIdToIdMap(e);
      return t.map((t) => this.getId(e, t, r, n));
    }
    getRemoteId(e, t, r) {
      let n = r || this.getRemoteIdToIdMap(e);
      if ("number" != typeof t) return t;
      let i = n.get(t);
      return i || -1;
    }
    getRemoteIds(e, t) {
      let r = this.getRemoteIdToIdMap(e);
      return t.map((t) => this.getRemoteId(e, t, r));
    }
    reset(e) {
      if (!e) {
        ((this.iframeIdToRemoteIdMap = new WeakMap()),
          (this.iframeRemoteIdToIdMap = new WeakMap()));
        return;
      }
      (this.iframeIdToRemoteIdMap.delete(e), this.iframeRemoteIdToIdMap.delete(e));
    }
    getIdToRemoteIdMap(e) {
      let t = this.iframeIdToRemoteIdMap.get(e);
      return (t || ((t = new Map()), this.iframeIdToRemoteIdMap.set(e, t)), t);
    }
    getRemoteIdToIdMap(e) {
      let t = this.iframeRemoteIdToIdMap.get(e);
      return (t || ((t = new Map()), this.iframeRemoteIdToIdMap.set(e, t)), t);
    }
  }
  class td {
    constructor() {
      ((this.crossOriginIframeMirror = new tu(ec)),
        (this.crossOriginIframeRootIdMap = new WeakMap()));
    }
    addIframe() {}
    addLoadListener() {}
    attachIframe() {}
  }
  class th {
    constructor(e) {
      ((this.iframes = new WeakMap()),
        (this.crossOriginIframeMap = new WeakMap()),
        (this.crossOriginIframeMirror = new tu(ec)),
        (this.crossOriginIframeRootIdMap = new WeakMap()),
        (this.mutationCb = e.mutationCb),
        (this.wrappedEmit = e.wrappedEmit),
        (this.stylesheetManager = e.stylesheetManager),
        (this.recordCrossOriginIframes = e.recordCrossOriginIframes),
        (this.crossOriginIframeStyleMirror = new tu(
          this.stylesheetManager.styleMirror.generateId.bind(this.stylesheetManager.styleMirror),
        )),
        (this.mirror = e.mirror),
        this.recordCrossOriginIframes &&
          window.addEventListener("message", this.handleMessage.bind(this)));
    }
    addIframe(e) {
      (this.iframes.set(e, !0),
        e.contentWindow && this.crossOriginIframeMap.set(e.contentWindow, e));
    }
    addLoadListener(e) {
      this.loadListener = e;
    }
    attachIframe(e, t) {
      (this.mutationCb({
        adds: [{ parentId: this.mirror.getId(e), nextId: null, node: t }],
        removes: [],
        texts: [],
        attributes: [],
        isAttachIframe: !0,
      }),
        this.recordCrossOriginIframes &&
          e.contentWindow?.addEventListener("message", this.handleMessage.bind(this)),
        this.loadListener?.(e));
      let r = e0(e);
      r &&
        r.adoptedStyleSheets &&
        r.adoptedStyleSheets.length > 0 &&
        this.stylesheetManager.adoptStyleSheets(r.adoptedStyleSheets, this.mirror.getId(r));
    }
    handleMessage(e) {
      if ("rrweb" !== e.data.type || e.origin !== e.data.origin || !e.source) return;
      let t = this.crossOriginIframeMap.get(e.source);
      if (!t) return;
      let r = this.transformCrossOriginEvent(t, e.data.event);
      r && this.wrappedEmit(r, e.data.isCheckout);
    }
    transformCrossOriginEvent(e, t) {
      switch (t.type) {
        case eG.FullSnapshot: {
          (this.crossOriginIframeMirror.reset(e),
            this.crossOriginIframeStyleMirror.reset(e),
            this.replaceIdOnNode(t.data.node, e));
          let r = t.data.node.id;
          return (
            this.crossOriginIframeRootIdMap.set(e, r),
            this.patchRootIdOnNode(t.data.node, r),
            {
              timestamp: t.timestamp,
              type: eG.IncrementalSnapshot,
              data: {
                source: eY.Mutation,
                adds: [{ parentId: this.mirror.getId(e), nextId: null, node: t.data.node }],
                removes: [],
                texts: [],
                attributes: [],
                isAttachIframe: !0,
              },
            }
          );
        }
        case eG.Meta:
        case eG.Load:
        case eG.DomContentLoaded:
          break;
        case eG.Plugin:
          return t;
        case eG.Custom:
          return (
            this.replaceIds(t.data.payload, e, ["id", "parentId", "previousId", "nextId"]),
            t
          );
        case eG.IncrementalSnapshot:
          switch (t.data.source) {
            case eY.Mutation:
              return (
                t.data.adds.forEach((t) => {
                  (this.replaceIds(t, e, ["parentId", "nextId", "previousId"]),
                    this.replaceIdOnNode(t.node, e));
                  let r = this.crossOriginIframeRootIdMap.get(e);
                  r && this.patchRootIdOnNode(t.node, r);
                }),
                t.data.removes.forEach((t) => {
                  this.replaceIds(t, e, ["parentId", "id"]);
                }),
                t.data.attributes.forEach((t) => {
                  this.replaceIds(t, e, ["id"]);
                }),
                t.data.texts.forEach((t) => {
                  this.replaceIds(t, e, ["id"]);
                }),
                t
              );
            case eY.Drag:
            case eY.TouchMove:
            case eY.MouseMove:
              return (
                t.data.positions.forEach((t) => {
                  this.replaceIds(t, e, ["id"]);
                }),
                t
              );
            case eY.ViewportResize:
              return !1;
            case eY.MediaInteraction:
            case eY.MouseInteraction:
            case eY.Scroll:
            case eY.CanvasMutation:
            case eY.Input:
              return (this.replaceIds(t.data, e, ["id"]), t);
            case eY.StyleSheetRule:
            case eY.StyleDeclaration:
              return (
                this.replaceIds(t.data, e, ["id"]),
                this.replaceStyleIds(t.data, e, ["styleId"]),
                t
              );
            case eY.Font:
              return t;
            case eY.Selection:
              return (
                t.data.ranges.forEach((t) => {
                  this.replaceIds(t, e, ["start", "end"]);
                }),
                t
              );
            case eY.AdoptedStyleSheet:
              return (
                this.replaceIds(t.data, e, ["id"]),
                this.replaceStyleIds(t.data, e, ["styleIds"]),
                t.data.styles?.forEach((t) => {
                  this.replaceStyleIds(t, e, ["styleId"]);
                }),
                t
              );
          }
      }
      return !1;
    }
    replace(e, t, r, n) {
      for (let i of n)
        (Array.isArray(t[i]) || "number" == typeof t[i]) &&
          (Array.isArray(t[i]) ? (t[i] = e.getIds(r, t[i])) : (t[i] = e.getId(r, t[i])));
      return t;
    }
    replaceIds(e, t, r) {
      return this.replace(this.crossOriginIframeMirror, e, t, r);
    }
    replaceStyleIds(e, t, r) {
      return this.replace(this.crossOriginIframeStyleMirror, e, t, r);
    }
    replaceIdOnNode(e, t) {
      (this.replaceIds(e, t, ["id", "rootId"]),
        "childNodes" in e &&
          e.childNodes.forEach((e) => {
            this.replaceIdOnNode(e, t);
          }));
    }
    patchRootIdOnNode(e, t) {
      (e.type === j.Document || e.rootId || (e.rootId = t),
        "childNodes" in e &&
          e.childNodes.forEach((e) => {
            this.patchRootIdOnNode(e, t);
          }));
    }
  }
  class tp {
    init() {}
    addShadowRoot() {}
    observeAttachShadow() {}
    reset() {}
  }
  class tf {
    constructor(e) {
      ((this.shadowDoms = new WeakSet()),
        (this.restoreHandlers = []),
        (this.mutationCb = e.mutationCb),
        (this.scrollCb = e.scrollCb),
        (this.bypassOptions = e.bypassOptions),
        (this.mirror = e.mirror),
        this.init());
    }
    init() {
      (this.reset(), this.patchAttachShadow(Element, document));
    }
    addShadowRoot(e, t) {
      if (!$(e) || this.shadowDoms.has(e)) return;
      (this.shadowDoms.add(e), this.bypassOptions.canvasManager.addShadowRoot(e));
      let r = te(
        {
          ...this.bypassOptions,
          doc: t,
          mutationCb: this.mutationCb,
          mirror: this.mirror,
          shadowDomManager: this,
        },
        e,
      );
      (this.restoreHandlers.push(() => r.disconnect()),
        this.restoreHandlers.push(
          tt({ ...this.bypassOptions, scrollCb: this.scrollCb, doc: e, mirror: this.mirror }),
        ),
        eJ(() => {
          (e.adoptedStyleSheets &&
            e.adoptedStyleSheets.length > 0 &&
            this.bypassOptions.stylesheetManager.adoptStyleSheets(
              e.adoptedStyleSheets,
              this.mirror.getId(e.host),
            ),
            this.restoreHandlers.push(
              to(
                { mirror: this.mirror, stylesheetManager: this.bypassOptions.stylesheetManager },
                e,
              ),
            ));
        }, 0));
    }
    observeAttachShadow(e) {
      let t = e0(e),
        r = (function (e) {
          try {
            return e.contentWindow;
          } catch (e) {}
        })(e);
      t && r && this.patchAttachShadow(r.Element, t);
    }
    patchAttachShadow(e, t) {
      let r = this;
      this.restoreHandlers.push(
        eO(e.prototype, "attachShadow", function (e) {
          return function (n) {
            let i = e.call(this, n);
            return (this.shadowRoot && eq(this) && r.addShadowRoot(this.shadowRoot, t), i);
          };
        }),
      );
    }
    reset() {
      (this.restoreHandlers.forEach((e) => {
        try {
          e();
        } catch (e) {}
      }),
        (this.restoreHandlers = []),
        (this.shadowDoms = new WeakSet()),
        this.bypassOptions.canvasManager.resetShadowRoots());
    }
  }
  for (
    var tm = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/",
      ty = "undefined" == typeof Uint8Array ? [] : new Uint8Array(256),
      tg = 0;
    tg < tm.length;
    tg++
  )
    ty[tm.charCodeAt(tg)] = tg;
  class tS {
    reset() {}
    freeze() {}
    unfreeze() {}
    lock() {}
    unlock() {}
    snapshot() {}
    addWindow() {}
    addShadowRoot() {}
    resetShadowRoots() {}
  }
  class tv {
    constructor(e) {
      ((this.trackedLinkElements = new WeakSet()),
        (this.styleMirror = new eH()),
        (this.mutationCb = e.mutationCb),
        (this.adoptedStyleSheetCb = e.adoptedStyleSheetCb));
    }
    attachLinkElement(e, t) {
      ("_cssText" in t.attributes &&
        this.mutationCb({
          adds: [],
          removes: [],
          texts: [],
          attributes: [{ id: t.id, attributes: t.attributes }],
        }),
        this.trackLinkElement(e));
    }
    trackLinkElement(e) {
      this.trackedLinkElements.has(e) ||
        (this.trackedLinkElements.add(e), this.trackStylesheetInLinkElement(e));
    }
    adoptStyleSheets(e, t) {
      if (0 === e.length) return;
      let r = { id: t, styleIds: [] },
        n = [];
      for (let t of e) {
        let e;
        (this.styleMirror.has(t)
          ? (e = this.styleMirror.getId(t))
          : ((e = this.styleMirror.add(t)),
            n.push({
              styleId: e,
              rules: Array.from(t.rules || CSSRule, (e, t) => ({ rule: K(e), index: t })),
            })),
          r.styleIds.push(e));
      }
      (n.length > 0 && (r.styles = n), this.adoptedStyleSheetCb(r));
    }
    reset() {
      (this.styleMirror.reset(), (this.trackedLinkElements = new WeakSet()));
    }
    trackStylesheetInLinkElement(e) {}
  }
  class t_ {
    constructor() {
      ((this.nodeMap = new WeakMap()), (this.active = !1));
    }
    inOtherBuffer(e, t) {
      let r = this.nodeMap.get(e);
      return r && Array.from(r).some((e) => e !== t);
    }
    add(e, t) {
      (this.active ||
        ((this.active = !0),
        (function (...e) {
          eV("requestAnimationFrame")(...e);
        })(() => {
          ((this.nodeMap = new WeakMap()), (this.active = !1));
        })),
        this.nodeMap.set(e, (this.nodeMap.get(e) || new Set()).add(t)));
    }
    destroy() {}
  }
  try {
    if (2 !== Array.from([1], (e) => 2 * e)[0]) {
      let e = document.createElement("iframe");
      (document.body.appendChild(e),
        (Array.from = e.contentWindow?.Array.from || Array.from),
        document.body.removeChild(e));
    }
  } catch (e) {
    console.debug("Unable to override Array.from", e);
  }
  let tw = new V();
  function tb(e = {}) {
    let t,
      {
        emit: r,
        checkoutEveryNms: n,
        checkoutEveryNth: i,
        blockClass: l = "rr-block",
        blockSelector: c = null,
        unblockSelector: u = null,
        ignoreClass: d = "rr-ignore",
        ignoreSelector: h = null,
        maskAllText: p = !1,
        maskTextClass: f = "rr-mask",
        unmaskTextClass: m = null,
        maskTextSelector: y = null,
        unmaskTextSelector: g = null,
        inlineStylesheet: S = !0,
        maskAllInputs: v,
        maskInputOptions: _,
        slimDOMOptions: w,
        maskAttributeFn: b,
        maskInputFn: k,
        maskTextFn: E,
        maxCanvasSize: M = null,
        packFn: I,
        sampling: C = {},
        dataURLOptions: R = {},
        mousemoveWait: T,
        recordDOM: x = !0,
        recordCanvas: O = !1,
        recordCrossOriginIframes: D = !1,
        recordAfter: N = "DOMContentLoaded" === e.recordAfter ? e.recordAfter : "load",
        userTriggeredOnInput: A = !1,
        collectFonts: L = !1,
        inlineImages: P = !1,
        plugins: F,
        keepIframeSrcFn: B = () => !1,
        ignoreCSSAttributes: U = new Set([]),
        errorHandler: z,
        onMutation: W,
        getCanvasManager: j,
      } = e;
    s = z;
    let H = !D || window.parent === window,
      $ = !1;
    if (!H)
      try {
        window.parent.document && ($ = !1);
      } catch (e) {
        $ = !0;
      }
    if (H && !r) throw Error("emit function is required");
    if (!H && !$) return () => {};
    (void 0 !== T && void 0 === C.mousemove && (C.mousemove = T), tw.reset());
    let q =
        !0 === v
          ? {
              color: !0,
              date: !0,
              "datetime-local": !0,
              email: !0,
              month: !0,
              number: !0,
              range: !0,
              search: !0,
              tel: !0,
              text: !0,
              time: !0,
              url: !0,
              week: !0,
              textarea: !0,
              select: !0,
              radio: !0,
              checkbox: !0,
            }
          : void 0 !== _
            ? _
            : {},
      K =
        !0 === w || "all" === w
          ? {
              script: !0,
              comment: !0,
              headFavicon: !0,
              headWhitespace: !0,
              headMetaSocial: !0,
              headMetaRobots: !0,
              headMetaHttpEquiv: !0,
              headMetaVerification: !0,
              headMetaAuthorship: "all" === w,
              headMetaDescKeywords: "all" === w,
            }
          : w || {};
    !(function (e = window) {
      ("NodeList" in e &&
        !e.NodeList.prototype.forEach &&
        (e.NodeList.prototype.forEach = Array.prototype.forEach),
        "DOMTokenList" in e &&
          !e.DOMTokenList.prototype.forEach &&
          (e.DOMTokenList.prototype.forEach = Array.prototype.forEach),
        Node.prototype.contains ||
          (Node.prototype.contains = (...e) => {
            let t = e[0];
            if (!(0 in e)) throw TypeError("1 argument is required");
            do if (this === t) return !0;
            while ((t = t && t.parentNode));
            return !1;
          }));
    })();
    let J = 0,
      G = (e) => {
        for (let t of F || []) t.eventProcessor && (e = t.eventProcessor(e));
        return (I && !$ && (e = I(e)), e);
      };
    o = (e, s) => {
      if (
        ((e.timestamp = eD()),
        e7[0]?.isFrozen() &&
          e.type !== eG.FullSnapshot &&
          (e.type !== eG.IncrementalSnapshot || e.data.source !== eY.Mutation) &&
          e7.forEach((e) => e.unfreeze()),
        H)
      )
        r?.(G(e), s);
      else if ($) {
        let t = { type: "rrweb", event: G(e), origin: window.location.origin, isCheckout: s };
        window.parent.postMessage(t, "*");
      }
      if (e.type === eG.FullSnapshot) ((t = e), (J = 0));
      else if (e.type === eG.IncrementalSnapshot) {
        if (e.data.source === eY.Mutation && e.data.isAttachIframe) return;
        J++;
        let r = i && J >= i,
          s = n && t && e.timestamp - t.timestamp > n;
        (r || s) && ei(!0);
      }
    };
    let Y = (e) => {
        o({ type: eG.IncrementalSnapshot, data: { source: eY.Mutation, ...e } });
      },
      X = (e) => o({ type: eG.IncrementalSnapshot, data: { source: eY.Scroll, ...e } }),
      Q = (e) => o({ type: eG.IncrementalSnapshot, data: { source: eY.CanvasMutation, ...e } }),
      Z = new tv({
        mutationCb: Y,
        adoptedStyleSheetCb: (e) =>
          o({ type: eG.IncrementalSnapshot, data: { source: eY.AdoptedStyleSheet, ...e } }),
      }),
      ee =
        "boolean" == typeof __RRWEB_EXCLUDE_IFRAME__ && __RRWEB_EXCLUDE_IFRAME__
          ? new td()
          : new th({
              mirror: tw,
              mutationCb: Y,
              stylesheetManager: Z,
              recordCrossOriginIframes: D,
              wrappedEmit: o,
            });
    for (let e of F || [])
      e.getMirror &&
        e.getMirror({
          nodeMirror: tw,
          crossOriginIframeMirror: ee.crossOriginIframeMirror,
          crossOriginIframeStyleMirror: ee.crossOriginIframeStyleMirror,
        });
    let et = new t_(),
      er = (function (e, t) {
        try {
          return e ? e(t) : new tS();
        } catch {
          return (console.warn("Unable to initialize CanvasManager"), new tS());
        }
      })(j, {
        mirror: tw,
        win: window,
        mutationCb: (e) =>
          o({ type: eG.IncrementalSnapshot, data: { source: eY.CanvasMutation, ...e } }),
        recordCanvas: O,
        blockClass: l,
        blockSelector: c,
        unblockSelector: u,
        maxCanvasSize: M,
        sampling: C.canvas,
        dataURLOptions: R,
        errorHandler: z,
      }),
      en =
        "boolean" == typeof __RRWEB_EXCLUDE_SHADOW_DOM__ && __RRWEB_EXCLUDE_SHADOW_DOM__
          ? new tp()
          : new tf({
              mutationCb: Y,
              scrollCb: X,
              bypassOptions: {
                onMutation: W,
                blockClass: l,
                blockSelector: c,
                unblockSelector: u,
                maskAllText: p,
                maskTextClass: f,
                unmaskTextClass: m,
                maskTextSelector: y,
                unmaskTextSelector: g,
                inlineStylesheet: S,
                maskInputOptions: q,
                dataURLOptions: R,
                maskAttributeFn: b,
                maskTextFn: E,
                maskInputFn: k,
                recordCanvas: O,
                inlineImages: P,
                sampling: C,
                slimDOMOptions: K,
                iframeManager: ee,
                stylesheetManager: Z,
                canvasManager: er,
                keepIframeSrcFn: B,
                processedNodeManager: et,
                ignoreCSSAttributes: U,
              },
              mirror: tw,
            }),
      ei = (e = !1) => {
        if (!x) return;
        (o({ type: eG.Meta, data: { href: window.location.href, width: eL(), height: eA() } }, e),
          Z.reset(),
          en.init(),
          e7.forEach((e) => e.lock()));
        let t = (function (e, t) {
          let {
            mirror: r = new V(),
            blockClass: n = "rr-block",
            blockSelector: i = null,
            unblockSelector: s = null,
            maskAllText: o = !1,
            maskTextClass: a = "rr-mask",
            unmaskTextClass: l = null,
            maskTextSelector: c = null,
            unmaskTextSelector: u = null,
            inlineStylesheet: d = !0,
            inlineImages: h = !1,
            recordCanvas: p = !1,
            maskAllInputs: f = !1,
            maskAttributeFn: m,
            maskTextFn: y,
            maskInputFn: g,
            slimDOM: S = !1,
            dataURLOptions: v,
            preserveWhiteSpace: _,
            onSerialize: w,
            onIframeLoad: b,
            iframeLoadTimeout: k,
            onBlockedImageLoad: E,
            onStylesheetLoad: M,
            stylesheetLoadTimeout: I,
            keepIframeSrcFn: C = () => !1,
            ignoreCSSAttributes: R = new Set([]),
          } = t || {};
          return eI(e, {
            doc: e,
            mirror: r,
            blockClass: n,
            blockSelector: i,
            unblockSelector: s,
            maskAllText: o,
            maskTextClass: a,
            unmaskTextClass: l,
            maskTextSelector: c,
            unmaskTextSelector: u,
            skipChild: !1,
            inlineStylesheet: d,
            maskInputOptions:
              !0 === f
                ? {
                    color: !0,
                    date: !0,
                    "datetime-local": !0,
                    email: !0,
                    month: !0,
                    number: !0,
                    range: !0,
                    search: !0,
                    tel: !0,
                    text: !0,
                    time: !0,
                    url: !0,
                    week: !0,
                    textarea: !0,
                    select: !0,
                  }
                : !1 === f
                  ? {}
                  : f,
            maskAttributeFn: m,
            maskTextFn: y,
            maskInputFn: g,
            slimDOMOptions:
              !0 === S || "all" === S
                ? {
                    script: !0,
                    comment: !0,
                    headFavicon: !0,
                    headWhitespace: !0,
                    headMetaDescKeywords: "all" === S,
                    headMetaSocial: !0,
                    headMetaRobots: !0,
                    headMetaHttpEquiv: !0,
                    headMetaAuthorship: !0,
                    headMetaVerification: !0,
                  }
                : !1 === S
                  ? {}
                  : S,
            dataURLOptions: v,
            inlineImages: h,
            recordCanvas: p,
            preserveWhiteSpace: _,
            onSerialize: w,
            onIframeLoad: b,
            iframeLoadTimeout: k,
            onBlockedImageLoad: E,
            onStylesheetLoad: M,
            stylesheetLoadTimeout: I,
            keepIframeSrcFn: C,
            newlyAddedElement: !1,
            ignoreCSSAttributes: R,
          });
        })(document, {
          mirror: tw,
          blockClass: l,
          blockSelector: c,
          unblockSelector: u,
          maskAllText: p,
          maskTextClass: f,
          unmaskTextClass: m,
          maskTextSelector: y,
          unmaskTextSelector: g,
          inlineStylesheet: S,
          maskAllInputs: q,
          maskAttributeFn: b,
          maskInputFn: k,
          maskTextFn: E,
          slimDOM: K,
          dataURLOptions: R,
          recordCanvas: O,
          inlineImages: P,
          onSerialize: (e) => {
            (ez(e, tw) && ee.addIframe(e),
              eW(e, tw) && Z.trackLinkElement(e),
              ej(e) && en.addShadowRoot(e.shadowRoot, document));
          },
          onIframeLoad: (e, t) => {
            (ee.attachIframe(e, t),
              e.contentWindow && er.addWindow(e.contentWindow),
              en.observeAttachShadow(e));
          },
          onStylesheetLoad: (e, t) => {
            Z.attachLinkElement(e, t);
          },
          onBlockedImageLoad: (e, t, { width: r, height: n }) => {
            Y({
              adds: [],
              removes: [],
              texts: [],
              attributes: [
                { id: t.id, attributes: { style: { width: `${r}px`, height: `${n}px` } } },
              ],
            });
          },
          keepIframeSrcFn: B,
          ignoreCSSAttributes: U,
        });
        if (!t) return console.warn("Failed to snapshot the document");
        (o({ type: eG.FullSnapshot, data: { node: t, initialOffset: eN(window) } }),
          e7.forEach((e) => e.unlock()),
          document.adoptedStyleSheets &&
            document.adoptedStyleSheets.length > 0 &&
            Z.adoptStyleSheets(document.adoptedStyleSheets, tw.getId(document)));
      };
    a = ei;
    try {
      let e = [],
        t = (e) =>
          e4(ta)(
            {
              onMutation: W,
              mutationCb: Y,
              mousemoveCb: (e, t) =>
                o({ type: eG.IncrementalSnapshot, data: { source: t, positions: e } }),
              mouseInteractionCb: (e) =>
                o({ type: eG.IncrementalSnapshot, data: { source: eY.MouseInteraction, ...e } }),
              scrollCb: X,
              viewportResizeCb: (e) =>
                o({ type: eG.IncrementalSnapshot, data: { source: eY.ViewportResize, ...e } }),
              inputCb: (e) => o({ type: eG.IncrementalSnapshot, data: { source: eY.Input, ...e } }),
              mediaInteractionCb: (e) =>
                o({ type: eG.IncrementalSnapshot, data: { source: eY.MediaInteraction, ...e } }),
              styleSheetRuleCb: (e) =>
                o({ type: eG.IncrementalSnapshot, data: { source: eY.StyleSheetRule, ...e } }),
              styleDeclarationCb: (e) =>
                o({ type: eG.IncrementalSnapshot, data: { source: eY.StyleDeclaration, ...e } }),
              canvasMutationCb: Q,
              fontCb: (e) => o({ type: eG.IncrementalSnapshot, data: { source: eY.Font, ...e } }),
              selectionCb: (e) => {
                o({ type: eG.IncrementalSnapshot, data: { source: eY.Selection, ...e } });
              },
              customElementCb: (e) => {
                o({ type: eG.IncrementalSnapshot, data: { source: eY.CustomElement, ...e } });
              },
              blockClass: l,
              ignoreClass: d,
              ignoreSelector: h,
              maskAllText: p,
              maskTextClass: f,
              unmaskTextClass: m,
              maskTextSelector: y,
              unmaskTextSelector: g,
              maskInputOptions: q,
              inlineStylesheet: S,
              sampling: C,
              recordDOM: x,
              recordCanvas: O,
              inlineImages: P,
              userTriggeredOnInput: A,
              collectFonts: L,
              doc: e,
              maskAttributeFn: b,
              maskInputFn: k,
              maskTextFn: E,
              keepIframeSrcFn: B,
              blockSelector: c,
              unblockSelector: u,
              slimDOMOptions: K,
              dataURLOptions: R,
              mirror: tw,
              iframeManager: ee,
              stylesheetManager: Z,
              shadowDomManager: en,
              processedNodeManager: et,
              canvasManager: er,
              ignoreCSSAttributes: U,
              plugins:
                F?.filter((e) => e.observer)?.map((e) => ({
                  observer: e.observer,
                  options: e.options,
                  callback: (t) => o({ type: eG.Plugin, data: { plugin: e.name, payload: t } }),
                })) || [],
            },
            {},
          );
      ee.addLoadListener((r) => {
        try {
          e.push(t(r.contentDocument));
        } catch (e) {
          console.warn(e);
        }
      });
      let r = () => {
        (ei(), e.push(t(document)));
      };
      return (
        "interactive" === document.readyState || "complete" === document.readyState
          ? r()
          : (e.push(
              eC("DOMContentLoaded", () => {
                (o({ type: eG.DomContentLoaded, data: {} }), "DOMContentLoaded" === N && r());
              }),
            ),
            e.push(
              eC(
                "load",
                () => {
                  (o({ type: eG.Load, data: {} }), "load" === N && r());
                },
                window,
              ),
            )),
        () => {
          (e.forEach((e) => e()), et.destroy(), (a = void 0), (s = void 0));
        }
      );
    } catch (e) {
      console.warn(e);
    }
  }
  function tk(e) {
    return e > 0x2540be3ff ? e : 1e3 * e;
  }
  function tE(e) {
    return e > 0x2540be3ff ? e / 1e3 : e;
  }
  function tM(e, t) {
    "sentry.transaction" !== t.category &&
      (["ui.click", "ui.input"].includes(t.category)
        ? e.triggerUserActivity()
        : e.checkAndHandleExpiredSession(),
      e.addUpdate(
        () => (
          e.throttledAddEvent({
            type: eG.Custom,
            timestamp: 1e3 * (t.timestamp || 0),
            data: { tag: "breadcrumb", payload: (0, d.S8)(t, 10, 1e3) },
          }),
          "console" === t.category
        ),
      ));
  }
  function tI(e) {
    return e.closest("button,a") || e;
  }
  function tC(e) {
    let t = tR(e);
    return t && t instanceof Element ? tI(t) : t;
  }
  function tR(e) {
    var t;
    return "object" == typeof (t = e) && t && "target" in t ? e.target : e;
  }
  ((tb.mirror = tw),
    (tb.takeFullSnapshot = function (e) {
      if (!a) throw Error("please take full snapshot after start recording");
      a(e);
    }),
    !(function (e) {
      ((e[(e.NotStarted = 0)] = "NotStarted"),
        (e[(e.Running = 1)] = "Running"),
        (e[(e.Stopped = 2)] = "Stopped"));
    })(c || (c = {})));
  let tT = new Set([
    eY.Mutation,
    eY.StyleSheetRule,
    eY.StyleDeclaration,
    eY.AdoptedStyleSheet,
    eY.CanvasMutation,
    eY.Selection,
    eY.MediaInteraction,
  ]);
  class tx {
    constructor(e, t, r = tM) {
      ((this._lastMutation = 0),
        (this._lastScroll = 0),
        (this._clicks = []),
        (this._timeout = t.timeout / 1e3),
        (this._threshold = t.threshold / 1e3),
        (this._scrollTimeout = t.scrollTimeout / 1e3),
        (this._replay = e),
        (this._ignoreSelector = t.ignoreSelector),
        (this._addBreadcrumbEvent = r));
    }
    addListeners() {
      var e;
      let t =
        ((e = () => {
          this._lastMutation = tD();
        }),
        l ||
          ((l = []),
          (0, h.GS)(F, "open", function (e) {
            return function (...t) {
              if (l)
                try {
                  l.forEach((e) => e());
                } catch {}
              return e.apply(F, t);
            };
          })),
        l.push(e),
        () => {
          let t = l ? l.indexOf(e) : -1;
          t > -1 && l.splice(t, 1);
        });
      this._teardown = () => {
        (t(), (this._clicks = []), (this._lastMutation = 0), (this._lastScroll = 0));
      };
    }
    removeListeners() {
      (this._teardown && this._teardown(),
        this._checkClickTimeout && clearTimeout(this._checkClickTimeout));
    }
    handleClick(e, t) {
      var r, n, i;
      if (
        ((r = t),
        (n = this._ignoreSelector),
        !tO.includes(r.tagName) ||
          ("INPUT" === r.tagName && !["submit", "button"].includes(r.getAttribute("type") || "")) ||
          ("A" === r.tagName &&
            (r.hasAttribute("download") ||
              (r.hasAttribute("target") && "_self" !== r.getAttribute("target")))) ||
          (n && r.matches(n)) ||
          !((i = e).data && "number" == typeof i.data.nodeId && i.timestamp))
      )
        return;
      let s = { timestamp: tE(e.timestamp), clickBreadcrumb: e, clickCount: 0, node: t };
      this._clicks.some((e) => e.node === s.node && 1 > Math.abs(e.timestamp - s.timestamp)) ||
        (this._clicks.push(s), 1 === this._clicks.length && this._scheduleCheckClicks());
    }
    registerMutation(e = Date.now()) {
      this._lastMutation = tE(e);
    }
    registerScroll(e = Date.now()) {
      this._lastScroll = tE(e);
    }
    registerClick(e) {
      let t = tI(e);
      this._handleMultiClick(t);
    }
    _handleMultiClick(e) {
      this._getClicks(e).forEach((e) => {
        e.clickCount++;
      });
    }
    _getClicks(e) {
      return this._clicks.filter((t) => t.node === e);
    }
    _checkClicks() {
      let e = [],
        t = tD();
      for (let r of (this._clicks.forEach((r) => {
        (!r.mutationAfter &&
          this._lastMutation &&
          (r.mutationAfter =
            r.timestamp <= this._lastMutation ? this._lastMutation - r.timestamp : void 0),
          !r.scrollAfter &&
            this._lastScroll &&
            (r.scrollAfter =
              r.timestamp <= this._lastScroll ? this._lastScroll - r.timestamp : void 0),
          r.timestamp + this._timeout <= t && e.push(r));
      }),
      e)) {
        let e = this._clicks.indexOf(r);
        e > -1 && (this._generateBreadcrumbs(r), this._clicks.splice(e, 1));
      }
      this._clicks.length && this._scheduleCheckClicks();
    }
    _generateBreadcrumbs(e) {
      let t = this._replay,
        r = e.scrollAfter && e.scrollAfter <= this._scrollTimeout,
        n = e.mutationAfter && e.mutationAfter <= this._threshold,
        { clickCount: i, clickBreadcrumb: s } = e;
      if (!r && !n) {
        let r = 1e3 * Math.min(e.mutationAfter || this._timeout, this._timeout),
          n = r < 1e3 * this._timeout ? "mutation" : "timeout",
          o = {
            type: "default",
            message: s.message,
            timestamp: s.timestamp,
            category: "ui.slowClickDetected",
            data: {
              ...s.data,
              url: F.location.href,
              route: t.getCurrentRoute(),
              timeAfterClickMs: r,
              endReason: n,
              clickCount: i || 1,
            },
          };
        this._addBreadcrumbEvent(t, o);
        return;
      }
      if (i > 1) {
        let e = {
          type: "default",
          message: s.message,
          timestamp: s.timestamp,
          category: "ui.multiClick",
          data: {
            ...s.data,
            url: F.location.href,
            route: t.getCurrentRoute(),
            clickCount: i,
            metric: !0,
          },
        };
        this._addBreadcrumbEvent(t, e);
      }
    }
    _scheduleCheckClicks() {
      (this._checkClickTimeout && clearTimeout(this._checkClickTimeout),
        (this._checkClickTimeout = (0, O.wg)(() => this._checkClicks(), 1e3)));
    }
  }
  let tO = ["A", "BUTTON", "INPUT"];
  function tD() {
    return Date.now() / 1e3;
  }
  function tN(e) {
    return { timestamp: Date.now() / 1e3, type: "default", ...e };
  }
  var tA = ((e) => (
    (e[(e.Document = 0)] = "Document"),
    (e[(e.DocumentType = 1)] = "DocumentType"),
    (e[(e.Element = 2)] = "Element"),
    (e[(e.Text = 3)] = "Text"),
    (e[(e.CDATA = 4)] = "CDATA"),
    (e[(e.Comment = 5)] = "Comment"),
    e
  ))(tA || {});
  let tL = new Set([
    "id",
    "class",
    "aria-label",
    "role",
    "name",
    "alt",
    "title",
    "data-test-id",
    "data-testid",
    "disabled",
    "aria-disabled",
    "data-sentry-component",
  ]);
  function tP(e, t) {
    let r = tb.mirror.getId(e),
      n = r && tb.mirror.getNode(r),
      i = n && tb.mirror.getMeta(n),
      s = i && i.type === tA.Element ? i : null;
    return {
      message: t,
      data: s
        ? {
            nodeId: r,
            node: {
              id: r,
              tagName: s.tagName,
              textContent: Array.from(s.childNodes)
                .map((e) => e.type === tA.Text && e.textContent)
                .filter(Boolean)
                .map((e) => e.trim())
                .join(""),
              attributes: (function (e) {
                let t = {};
                for (let r in (!e["data-sentry-component"] &&
                  e["data-sentry-element"] &&
                  (e["data-sentry-component"] = e["data-sentry-element"]),
                e))
                  if (tL.has(r)) {
                    let n = r;
                    (("data-testid" === r || "data-test-id" === r) && (n = "testId"),
                      (t[n] = e[r]));
                  }
                return t;
              })(s.attributes),
            },
          }
        : {},
    };
  }
  let tF = {
    resource: function (e) {
      let {
        entryType: t,
        initiatorType: r,
        name: n,
        responseEnd: i,
        startTime: s,
        decodedBodySize: o,
        encodedBodySize: a,
        responseStatus: l,
        transferSize: c,
      } = e;
      return ["fetch", "xmlhttprequest"].includes(r)
        ? null
        : {
            type: `${t}.${r}`,
            start: tz(s),
            end: tz(i),
            name: n,
            data: { size: c, statusCode: l, decodedBodySize: o, encodedBodySize: a },
          };
    },
    paint: function (e) {
      let { duration: t, entryType: r, name: n, startTime: i } = e,
        s = tz(i);
      return { type: r, name: n, start: s, end: s + t, data: void 0 };
    },
    navigation: function (e) {
      let {
        entryType: t,
        name: r,
        decodedBodySize: n,
        duration: i,
        domComplete: s,
        encodedBodySize: o,
        domContentLoadedEventStart: a,
        domContentLoadedEventEnd: l,
        domInteractive: c,
        loadEventStart: u,
        loadEventEnd: d,
        redirectCount: h,
        startTime: p,
        transferSize: f,
        type: m,
      } = e;
      return 0 === i
        ? null
        : {
            type: `${t}.${m}`,
            start: tz(p),
            end: tz(s),
            name: r,
            data: {
              size: f,
              decodedBodySize: n,
              encodedBodySize: o,
              duration: i,
              domInteractive: c,
              domContentLoadedEventStart: a,
              domContentLoadedEventEnd: l,
              loadEventStart: u,
              loadEventEnd: d,
              domComplete: s,
              redirectCount: h,
            },
          };
    },
  };
  function tB(e, t) {
    return ({ metric: r }) => void t.replayPerformanceEntries.push(e(r));
  }
  function tU(e) {
    let t = tF[e.entryType];
    return t ? t(e) : null;
  }
  function tz(e) {
    return (((0, f.k3)() || F.performance.timeOrigin) + e) / 1e3;
  }
  function tW(e) {
    let t = e.entries[e.entries.length - 1];
    return t$(e, "largest-contentful-paint", t?.element ? [t.element] : void 0);
  }
  function tj(e) {
    let t = [],
      r = [];
    for (let n of e.entries)
      if (void 0 !== n.sources) {
        let e = [];
        for (let t of n.sources)
          if (t.node) {
            r.push(t.node);
            let n = tb.mirror.getId(t.node);
            n && e.push(n);
          }
        t.push({ value: n.value, nodeIds: e.length ? e : void 0 });
      }
    return t$(e, "cumulative-layout-shift", r, t);
  }
  function tH(e) {
    let t = e.entries[e.entries.length - 1];
    return t$(e, "interaction-to-next-paint", t?.target ? [t.target] : void 0);
  }
  function t$(e, t, r, n) {
    let i = e.value,
      s = e.rating,
      o = tz(i);
    return {
      type: "web-vital",
      name: t,
      start: o,
      end: o,
      data: {
        value: i,
        size: i,
        rating: s,
        nodeIds: r ? r.map((e) => tb.mirror.getId(e)) : void 0,
        attributions: n,
      },
    };
  }
  let tq = ["log", "warn", "error"],
    tK = (function () {
      let e = {
        exception: () => void 0,
        infoTick: () => void 0,
        setConfig: (e) => {
          (e.captureExceptions, e.traceInternals);
        },
      };
      return (
        tq.forEach((t) => {
          e[t] = () => void 0;
        }),
        e
      );
    })();
  class tV extends Error {
    constructor() {
      super("Event buffer exceeded maximum size of 20000000.");
    }
  }
  class tJ {
    constructor() {
      ((this.events = []),
        (this._totalSize = 0),
        (this.hasCheckout = !1),
        (this.waitForCheckout = !1));
    }
    get hasEvents() {
      return this.events.length > 0;
    }
    get type() {
      return "sync";
    }
    destroy() {
      this.events = [];
    }
    async addEvent(e) {
      let t = JSON.stringify(e).length;
      if (((this._totalSize += t), this._totalSize > 2e7)) throw new tV();
      this.events.push(e);
    }
    finish() {
      return new Promise((e) => {
        let t = this.events;
        (this.clear(), e(JSON.stringify(t)));
      });
    }
    clear() {
      ((this.events = []), (this._totalSize = 0), (this.hasCheckout = !1));
    }
    getEarliestTimestamp() {
      let e = null;
      for (let { timestamp: t } of this.events) (null === e || t < e) && (e = t);
      return null === e ? e : tk(e);
    }
  }
  class tG {
    constructor(e) {
      ((this._worker = e), (this._id = 0));
    }
    ensureReady() {
      return (
        this._ensureReadyPromise ||
          (this._ensureReadyPromise = new Promise((e, t) => {
            (this._worker.addEventListener(
              "message",
              ({ data: r }) => {
                r.success ? e() : t(Error("Received worker message with unsuccessful status"));
              },
              { once: !0 },
            ),
              this._worker.addEventListener(
                "error",
                (e) => {
                  t(
                    Error(
                      `Failed to load Replay compression worker: ${e instanceof ErrorEvent && e.message ? e.message : "Unknown error. This can happen due to CSP policy restrictions, network issues, or the worker script failing to load."}`,
                    ),
                  );
                },
                { once: !0 },
              ));
          })),
        this._ensureReadyPromise
      );
    }
    destroy() {
      this._worker.terminate();
    }
    postMessage(e, t) {
      let r = this._getAndIncrementId();
      return new Promise((n, i) => {
        let s = ({ data: t }) => {
          if (t.method === e && t.id === r) {
            if ((this._worker.removeEventListener("message", s), !t.success))
              return void i(Error("Error in compression worker"));
            n(t.response);
          }
        };
        (this._worker.addEventListener("message", s),
          this._worker.postMessage({ id: r, method: e, arg: t }));
      });
    }
    _getAndIncrementId() {
      return this._id++;
    }
  }
  class tY {
    constructor(e) {
      ((this._worker = new tG(e)),
        (this._earliestTimestamp = null),
        (this._totalSize = 0),
        (this.hasCheckout = !1),
        (this.waitForCheckout = !1));
    }
    get hasEvents() {
      return !!this._earliestTimestamp;
    }
    get type() {
      return "worker";
    }
    ensureReady() {
      return this._worker.ensureReady();
    }
    destroy() {
      this._worker.destroy();
    }
    addEvent(e) {
      let t = tk(e.timestamp);
      (!this._earliestTimestamp || t < this._earliestTimestamp) && (this._earliestTimestamp = t);
      let r = JSON.stringify(e);
      return ((this._totalSize += r.length), this._totalSize > 2e7)
        ? Promise.reject(new tV())
        : this._sendEventToWorker(r);
    }
    finish() {
      return this._finishRequest();
    }
    clear() {
      ((this._earliestTimestamp = null),
        (this._totalSize = 0),
        (this.hasCheckout = !1),
        this._worker.postMessage("clear").then(null, (e) => {}));
    }
    getEarliestTimestamp() {
      return this._earliestTimestamp;
    }
    _sendEventToWorker(e) {
      return this._worker.postMessage("addEvent", e);
    }
    async _finishRequest() {
      let e = await this._worker.postMessage("finish");
      return ((this._earliestTimestamp = null), (this._totalSize = 0), e);
    }
  }
  class tX {
    constructor(e) {
      ((this._fallback = new tJ()),
        (this._compression = new tY(e)),
        (this._used = this._fallback),
        (this._ensureWorkerIsLoadedPromise = this._ensureWorkerIsLoaded()));
    }
    get waitForCheckout() {
      return this._used.waitForCheckout;
    }
    get type() {
      return this._used.type;
    }
    get hasEvents() {
      return this._used.hasEvents;
    }
    get hasCheckout() {
      return this._used.hasCheckout;
    }
    set hasCheckout(e) {
      this._used.hasCheckout = e;
    }
    set waitForCheckout(e) {
      this._used.waitForCheckout = e;
    }
    destroy() {
      (this._fallback.destroy(), this._compression.destroy());
    }
    clear() {
      return this._used.clear();
    }
    getEarliestTimestamp() {
      return this._used.getEarliestTimestamp();
    }
    addEvent(e) {
      return this._used.addEvent(e);
    }
    async finish() {
      return (await this.ensureWorkerIsLoaded(), this._used.finish());
    }
    ensureWorkerIsLoaded() {
      return this._ensureWorkerIsLoadedPromise;
    }
    async _ensureWorkerIsLoaded() {
      try {
        await this._compression.ensureReady();
      } catch (e) {
        return;
      }
      await this._switchToCompressionWorker();
    }
    async _switchToCompressionWorker() {
      let { events: e, hasCheckout: t, waitForCheckout: r } = this._fallback,
        n = [];
      for (let t of e) n.push(this._compression.addEvent(t));
      ((this._compression.hasCheckout = t),
        (this._compression.waitForCheckout = r),
        (this._used = this._compression));
      try {
        (await Promise.all(n), this._fallback.clear());
      } catch (e) {}
    }
  }
  function tQ() {
    try {
      return "sessionStorage" in F && !!F.sessionStorage;
    } catch {
      return !1;
    }
  }
  function tZ(e) {
    return void 0 !== e && Math.random() < e;
  }
  function t0(e) {
    if (tQ())
      try {
        F.sessionStorage.setItem(B, JSON.stringify(e));
      } catch {}
  }
  function t1(e) {
    let t = Date.now(),
      r = e.id || (0, S.eJ)(),
      n = e.started || t,
      i = e.lastActivity || t,
      s = e.segmentId || 0,
      o = e.sampled;
    return {
      id: r,
      started: n,
      lastActivity: i,
      segmentId: s,
      sampled: o,
      previousSessionId: e.previousSessionId,
      dirty: e.dirty || !1,
    };
  }
  function t2(
    { sessionSampleRate: e, allowBuffering: t, stickySession: r = !1 },
    { previousSessionId: n } = {},
  ) {
    let i = t1({ sampled: tZ(e) ? "session" : !!t && "buffer", previousSessionId: n });
    return (r && t0(i), i);
  }
  function t3(e, t, r = +new Date()) {
    return null === e || void 0 === t || t < 0 || (0 !== t && e + t <= r);
  }
  function t5(e, { maxReplayDuration: t, sessionIdleExpire: r, targetTime: n = Date.now() }) {
    return t3(e.started, t, n) || t3(e.lastActivity, r, n);
  }
  function t8(e, { sessionIdleExpire: t, maxReplayDuration: r }) {
    return (
      !!t5(e, { sessionIdleExpire: t, maxReplayDuration: r }) &&
      ("buffer" !== e.sampled || 0 !== e.segmentId)
    );
  }
  function t6({ sessionIdleExpire: e, maxReplayDuration: t, previousSessionId: r }, n) {
    let i =
      n.stickySession &&
      (function () {
        if (!tQ()) return null;
        try {
          let e = F.sessionStorage.getItem(B);
          if (!e) return null;
          let t = JSON.parse(e);
          return t1(t);
        } catch {
          return null;
        }
      })();
    return i
      ? t8(i, { sessionIdleExpire: e, maxReplayDuration: t })
        ? t2(n, { previousSessionId: i.id })
        : i
      : t2(n, { previousSessionId: r });
  }
  function t4(e, t, r) {
    return !!t9(e, t) && (t7(e, t, r), !0);
  }
  async function t7(e, t, r) {
    let { eventBuffer: n } = e;
    if (!n || (n.waitForCheckout && !r)) return null;
    let i = "buffer" === e.recordingMode;
    try {
      (r && i && n.clear(), r && ((n.hasCheckout = !0), (n.waitForCheckout = !1)));
      let s = e.getOptions(),
        o = (function (e, t) {
          try {
            if ("function" == typeof t && e.type === eG.Custom) return t(e);
          } catch (e) {
            return null;
          }
          return e;
        })(t, s.beforeAddRecordingEvent);
      if (!o) return;
      return await n.addEvent(o);
    } catch (s) {
      let t = s && s instanceof tV,
        r = (0, v.KU)();
      if (
        (r && r.recordDroppedEvent(t ? "buffer_overflow" : "internal_sdk_error", "replay"), t && i)
      )
        return (n.clear(), (n.waitForCheckout = !0), null);
      (e.handleException(s), await e.stop({ reason: t ? "addEventSizeExceeded" : "addEvent" }));
    }
  }
  function t9(e, t) {
    if (!e.eventBuffer || e.isPaused() || !e.isEnabled()) return !1;
    let r = tk(t.timestamp);
    return (
      !(r + e.timeouts.sessionIdlePause < Date.now()) &&
      !(r > e.getContext().initialTimestamp + e.getOptions().maxReplayDuration)
    );
  }
  function re(e) {
    return "transaction" === e.type;
  }
  function rt(e) {
    return "feedback" === e.type;
  }
  function rr(e) {
    return !!e.category;
  }
  function rn() {
    let e = (0, v.o5)().getPropagationContext().dsc;
    e && delete e.replay_id;
    let t = (0, _.Bk)();
    if (t) {
      let e = (0, w.k1)(t);
      delete e.replay_id;
    }
  }
  function ri(e, t) {
    return t.map(({ type: t, start: r, end: n, name: i, data: s }) => {
      let o = e.throttledAddEvent({
        type: eG.Custom,
        timestamp: r,
        data: {
          tag: "performanceSpan",
          payload: { op: t, description: i, startTimestamp: r, endTimestamp: n, data: s },
        },
      });
      return "string" == typeof o ? Promise.resolve(null) : o;
    });
  }
  function rs(e, t) {
    var r;
    e.isEnabled() &&
      null !== t &&
      ((r = t.name), (0, b.A)(r, (0, v.KU)()) || e.addUpdate(() => (ri(e, [t]), !0)));
  }
  function ro(e) {
    if (!e) return;
    let t = new TextEncoder();
    try {
      if ("string" == typeof e) return t.encode(e).length;
      if (e instanceof URLSearchParams) return t.encode(e.toString()).length;
      if (e instanceof FormData) {
        let r = (0, N.P4)(e);
        return t.encode(r).length;
      }
      if (e instanceof Blob) return e.size;
      if (e instanceof ArrayBuffer) return e.byteLength;
    } catch {}
  }
  function ra(e) {
    if (!e) return;
    let t = parseInt(e, 10);
    return isNaN(t) ? void 0 : t;
  }
  function rl(e, t) {
    if (!e) return { headers: {}, size: void 0, _meta: { warnings: [t] } };
    let r = { ...e._meta },
      n = r.warnings || [];
    return ((r.warnings = [...n, t]), (e._meta = r), e);
  }
  function rc(e, t) {
    if (!t) return null;
    let {
      startTimestamp: r,
      endTimestamp: n,
      url: i,
      method: s,
      statusCode: o,
      request: a,
      response: l,
    } = t;
    return {
      type: e,
      start: r / 1e3,
      end: n / 1e3,
      name: i,
      data: { method: s, statusCode: o, request: a, response: l },
    };
  }
  function ru(e) {
    return { headers: {}, size: e, _meta: { warnings: ["URL_SKIPPED"] } };
  }
  function rd(e, t, r) {
    if (!t && 0 === Object.keys(e).length) return;
    if (!t) return { headers: e };
    if (!r) return { headers: e, size: t };
    let n = { headers: e, size: t },
      { body: i, warnings: s } = (function (e) {
        if (!e || "string" != typeof e) return { body: e };
        let t = e.length > 15e4,
          r = (function (e) {
            let t = e[0],
              r = e[e.length - 1];
            return ("[" === t && "]" === r) || ("{" === t && "}" === r);
          })(e);
        if (t) {
          let t = e.slice(0, 15e4);
          return r
            ? { body: t, warnings: ["MAYBE_JSON_TRUNCATED"] }
            : { body: `${t}…`, warnings: ["TEXT_TRUNCATED"] };
        }
        if (r)
          try {
            return { body: JSON.parse(e) };
          } catch {}
        return { body: e };
      })(r);
    return ((n.body = i), s?.length && (n._meta = { warnings: s }), n);
  }
  function rh(e, t) {
    return Object.entries(e).reduce((r, [n, i]) => {
      let s = n.toLowerCase();
      return (t.includes(s) && e[n] && (r[s] = i), r);
    }, {});
  }
  function rp(e, t) {
    let r = (function (e, t = F.document.baseURI) {
      if (e.startsWith("http://") || e.startsWith("https://") || e.startsWith(F.location.origin))
        return e;
      let r = new URL(e, t);
      if (r.origin !== new URL(t).origin) return e;
      let n = r.href;
      return !e.endsWith("/") && n.endsWith("/") ? n.slice(0, -1) : n;
    })(e);
    return (0, k.Xr)(r, t);
  }
  async function rf(e, t, r) {
    try {
      let n = await rm(e, t, r),
        i = rc("resource.fetch", n);
      rs(r.replay, i);
    } catch (e) {}
  }
  async function rm(e, t, r) {
    let n = Date.now(),
      { startTimestamp: i = n, endTimestamp: s = n } = t,
      {
        url: o,
        method: a,
        status_code: l = 0,
        request_body_size: c,
        response_body_size: u,
      } = e.data,
      d = rp(o, r.networkDetailAllowUrls) && !rp(o, r.networkDetailDenyUrls);
    return {
      startTimestamp: i,
      endTimestamp: s,
      url: o,
      method: a,
      statusCode: l,
      request: d
        ? (function ({ networkCaptureBodies: e, networkRequestHeaders: t }, r, n) {
            var i, s;
            let o = r
              ? ((i = r),
                (s = t),
                1 === i.length && "string" != typeof i[0]
                  ? rv(i[0], s)
                  : 2 === i.length
                    ? rv(i[1], s)
                    : {})
              : {};
            if (!e) return rd(o, n, void 0);
            let a = (0, N.Gv)(r),
              [l, c] = (0, N.sY)(a, tK),
              u = rd(o, n, l);
            return c ? rl(u, c) : u;
          })(r, t.input, c)
        : ru(c),
      response: await ry(d, r, t.response, u),
    };
  }
  async function ry(e, { networkCaptureBodies: t, networkResponseHeaders: r }, n, i) {
    if (!e && void 0 !== i) return ru(i);
    let s = n ? rS(n.headers, r) : {};
    if (!n || (!t && void 0 !== i)) return rd(s, i, void 0);
    let [o, a] = await rg(n),
      l = (function (
        e,
        { networkCaptureBodies: t, responseBodySize: r, captureDetails: n, headers: i },
      ) {
        try {
          let s = e?.length && void 0 === r ? ro(e) : r;
          if (!n) return ru(s);
          if (t) return rd(i, s, e);
          return rd(i, s, void 0);
        } catch (e) {
          return rd(i, r, void 0);
        }
      })(o, { networkCaptureBodies: t, responseBodySize: i, captureDetails: e, headers: s });
    return a ? rl(l, a) : l;
  }
  async function rg(e) {
    let t = (function (e) {
      try {
        return e.clone();
      } catch (e) {}
    })(e);
    if (!t) return [void 0, "BODY_PARSE_ERROR"];
    try {
      var r;
      return [
        await ((r = t),
        new Promise((e, t) => {
          let n = (0, O.wg)(() => t(Error("Timeout while trying to read response body")), 500);
          r_(r)
            .then(
              (t) => e(t),
              (e) => t(e),
            )
            .finally(() => clearTimeout(n));
        })),
      ];
    } catch (e) {
      if (e instanceof Error && e.message.indexOf("Timeout") > -1)
        return [void 0, "BODY_PARSE_TIMEOUT"];
      return [void 0, "BODY_PARSE_ERROR"];
    }
  }
  function rS(e, t) {
    let r = {};
    return (
      t.forEach((t) => {
        e.get(t) && (r[t] = e.get(t));
      }),
      r
    );
  }
  function rv(e, t) {
    if (!e) return {};
    let r = e.headers;
    return r ? (r instanceof Headers ? rS(r, t) : Array.isArray(r) ? {} : rh(r, t)) : {};
  }
  async function r_(e) {
    return await e.text();
  }
  async function rw(e, t, r) {
    try {
      let n = (function (e, t, r) {
          let n = Date.now(),
            { startTimestamp: i = n, endTimestamp: s = n, input: o, xhr: a } = t,
            {
              url: l,
              method: c,
              status_code: u = 0,
              request_body_size: d,
              response_body_size: h,
            } = e.data;
          if (!l) return null;
          if (!a || !rp(l, r.networkDetailAllowUrls) || rp(l, r.networkDetailDenyUrls)) {
            let e = ru(d);
            return {
              startTimestamp: i,
              endTimestamp: s,
              url: l,
              method: c,
              statusCode: u,
              request: e,
              response: ru(h),
            };
          }
          let p = a[A.Er],
            f = p ? rh(p.request_headers, r.networkRequestHeaders) : {},
            m = rh((0, N.ti)(a), r.networkResponseHeaders),
            [y, g] = r.networkCaptureBodies ? (0, N.sY)(o, tK) : [void 0],
            [S, v] = r.networkCaptureBodies
              ? (function (e) {
                  let t = [];
                  try {
                    return [e.responseText];
                  } catch (e) {
                    t.push(e);
                  }
                  try {
                    var r = e.response,
                      n = e.responseType;
                    try {
                      if ("string" == typeof r) return [r];
                      if (r instanceof Document) return [r.body.outerHTML];
                      if ("json" === n && r && "object" == typeof r) return [JSON.stringify(r)];
                      if (!r) return [void 0];
                    } catch (e) {
                      return [void 0, "BODY_PARSE_ERROR"];
                    }
                    return [void 0, "UNPARSEABLE_BODY_TYPE"];
                  } catch (e) {
                    t.push(e);
                  }
                  return [void 0];
                })(a)
              : [void 0],
            _ = rd(f, d, y),
            w = rd(m, h, S);
          return {
            startTimestamp: i,
            endTimestamp: s,
            url: l,
            method: c,
            statusCode: u,
            request: g ? rl(_, g) : _,
            response: v ? rl(w, v) : w,
          };
        })(e, t, r),
        i = rc("resource.xhr", n);
      rs(r.replay, i);
    } catch (e) {}
  }
  async function rb(e) {
    try {
      return Promise.all(
        ri(e, [
          (function (e) {
            let { jsHeapSizeLimit: t, totalJSHeapSize: r, usedJSHeapSize: n } = e,
              i = Date.now() / 1e3;
            return {
              type: "memory",
              name: "memory",
              start: i,
              end: i,
              data: { memory: { jsHeapSizeLimit: t, totalJSHeapSize: r, usedJSHeapSize: n } },
            };
          })(F.performance.memory),
        ]),
      );
    } catch {
      return [];
    }
  }
  let rk = u.O.navigator;
  async function rE({ client: e, scope: t, replayId: r, event: n }) {
    let i = {
      event_id: r,
      integrations:
        "object" != typeof e._integrations ||
        null === e._integrations ||
        Array.isArray(e._integrations)
          ? void 0
          : Object.keys(e._integrations),
    };
    e.emit("preprocessEvent", n, i);
    let s = await (0, I.mG)(e.getOptions(), n, i, t, e, (0, v.rm)());
    if (!s) return null;
    (e.emit("postprocessEvent", s, i), (s.platform = s.platform || "javascript"));
    let o = e.getSdkMetadata(),
      { name: a, version: l, settings: c } = o?.sdk || {};
    return (
      (s.sdk = {
        ...s.sdk,
        name: a || "sentry.javascript.unknown",
        version: l || "0.0.0",
        settings: c,
      }),
      s
    );
  }
  async function rM({
    recordingData: e,
    replayId: t,
    segmentId: r,
    eventContext: n,
    timestamp: i,
    session: s,
  }) {
    var o;
    let a,
      l = (function ({ recordingData: e, headers: t }) {
        let r,
          n = `${JSON.stringify(t)}
`;
        if ("string" == typeof e) r = `${n}${e}`;
        else {
          let t = new TextEncoder().encode(n);
          ((r = new Uint8Array(t.length + e.length)).set(t), r.set(e, t.length));
        }
        return r;
      })({ recordingData: e, headers: { segment_id: r } }),
      { urls: c, errorIds: u, traceIds: d, initialTimestamp: h } = n,
      p = (0, v.KU)(),
      f = (0, v.o5)(),
      m = p?.getTransport(),
      y = p?.getDsn();
    if (!p || !m || !y || !s.sampled) return Promise.resolve({});
    let g = {
        type: "replay_event",
        replay_start_timestamp: h / 1e3,
        timestamp: i / 1e3,
        error_ids: u,
        trace_ids: d,
        urls: c,
        replay_id: t,
        segment_id: r,
        replay_type: s.sampled,
      },
      S = await rE({ scope: f, client: p, replayId: t, event: g });
    if (!S) return (p.recordDroppedEvent("event_processor", "replay"), Promise.resolve({}));
    delete S.sdkProcessingMetadata;
    let _ =
      ((o = p.getOptions().tunnel),
      (0, M.h4)((0, M.n2)(S, (0, M.Cj)(S), o, y), [
        [{ type: "replay_event" }, S],
        [
          {
            type: "replay_recording",
            length: "string" == typeof l ? new TextEncoder().encode(l).length : l.length,
          },
          l,
        ],
      ]));
    try {
      a = await m.send(_);
    } catch (t) {
      let e = Error(U);
      try {
        e.cause = t;
      } catch {}
      throw e;
    }
    let w = (0, C.wq)({}, a);
    if ((0, C.Jz)(w, "replay")) throw new rC(w);
    if ("number" == typeof a.statusCode && (a.statusCode < 200 || a.statusCode >= 300))
      throw new rI(a.statusCode);
    return a;
  }
  class rI extends Error {
    constructor(e) {
      super(`Transport returned status code ${e}`);
    }
  }
  class rC extends Error {
    constructor(e) {
      (super("Rate limit hit"), (this.rateLimits = e));
    }
  }
  class rR extends Error {
    constructor() {
      super("Session is too long, not sending replay");
    }
  }
  async function rT(e, t = { count: 0, interval: 5e3 }) {
    let { recordingData: r, onError: n } = e;
    if (r.length)
      try {
        return (await rM(e), !0);
      } catch (r) {
        if (r instanceof rI || r instanceof rC) throw r;
        if (((0, g.o)("Replays", { _retryCount: t.count }), n && n(r), t.count >= 3)) {
          let e = Error(`${U} - max retries exceeded`);
          try {
            e.cause = r;
          } catch {}
          throw e;
        }
        return (
          (t.interval *= ++t.count),
          new Promise((r, n) => {
            (0, O.wg)(async () => {
              try {
                (await rT(e, t), r(!0));
              } catch (e) {
                n(e);
              }
            }, t.interval);
          })
        );
      }
  }
  let rx = "__THROTTLED";
  class rO {
    constructor({ options: e, recordingOptions: t }) {
      var r, n, i;
      ((this.eventBuffer = null),
        (this.performanceEntries = []),
        (this.replayPerformanceEntries = []),
        (this.recordingMode = "session"),
        (this.timeouts = { sessionIdlePause: 3e5, sessionIdleExpire: 9e5 }),
        (this._lastActivity = Date.now()),
        (this._isEnabled = !1),
        (this._isPaused = !1),
        (this._requiresManualStart = !1),
        (this._hasInitializedCoreListeners = !1),
        (this._context = {
          errorIds: new Set(),
          traceIds: new Set(),
          urls: [],
          initialTimestamp: Date.now(),
          initialUrl: "",
        }),
        (this._recordingOptions = t),
        (this._options = e),
        (this._debouncedFlush =
          ((r = () => this._flush()),
          (n = this._options.flushMinDelay),
          (i = { maxWait: this._options.flushMaxDelay }),
          (0, E.s)(r, n, { ...i, setTimeoutImpl: O.wg }))),
        (this._throttledAddEvent = (function (e, t, r) {
          let n = new Map(),
            i = !1;
          return (...t) => {
            let r = Math.floor(Date.now() / 1e3),
              s = r - 5;
            if (
              (n.forEach((e, t) => {
                t < s && n.delete(t);
              }),
              [...n.values()].reduce((e, t) => e + t, 0) >= 300)
            ) {
              let e = i;
              return ((i = !0), e ? "__SKIPPED" : rx);
            }
            i = !1;
            let o = n.get(r) || 0;
            return (n.set(r, o + 1), e(...t));
          };
        })(
          (e, t) =>
            (function (e, t, r) {
              return t9(e, t) ? t7(e, t, r) : Promise.resolve(null);
            })(this, e, t),
          0,
          0,
        )));
      let { slowClickTimeout: s, slowClickIgnoreSelectors: o } = this.getOptions(),
        a = s
          ? {
              threshold: Math.min(3e3, s),
              timeout: s,
              scrollTimeout: 300,
              ignoreSelector: o ? o.join(",") : "",
            }
          : void 0;
      (a && (this.clickDetector = new tx(this, a)),
        (this._handleVisibilityChange = () => {
          "visible" === F.document.visibilityState
            ? this._doChangeToForegroundTasks()
            : this._doChangeToBackgroundTasks();
        }),
        (this._handleWindowBlur = () => {
          let e = tN({ category: "ui.blur" });
          this._doChangeToBackgroundTasks(e);
        }),
        (this._handleWindowFocus = () => {
          let e = tN({ category: "ui.focus" });
          this._doChangeToForegroundTasks(e);
        }),
        (this._handleKeyboardEvent = (e) => {
          !(function (e, t) {
            if (!e.isEnabled()) return;
            e.updateUserActivity();
            let r = (function (e) {
              var t;
              let { metaKey: r, shiftKey: n, ctrlKey: i, altKey: s, key: o, target: a } = e;
              if (
                !a ||
                "INPUT" === (t = a).tagName ||
                "TEXTAREA" === t.tagName ||
                t.isContentEditable ||
                !o
              )
                return null;
              let l = r || i || s,
                c = 1 === o.length;
              if (!l && c) return null;
              let u = (0, p.Hd)(a, { maxStringLength: 200 }) || "<unknown>",
                d = tP(a, u);
              return tN({
                category: "ui.keyDown",
                message: u,
                data: { ...d.data, metaKey: r, shiftKey: n, ctrlKey: i, altKey: s, key: o },
              });
            })(t);
            r && tM(e, r);
          })(this, e);
        }));
    }
    getContext() {
      return this._context;
    }
    isEnabled() {
      return this._isEnabled;
    }
    isPaused() {
      return this._isPaused;
    }
    isRecordingCanvas() {
      return !!this._canvas;
    }
    getOptions() {
      return this._options;
    }
    handleException(e) {
      this._options.onError && this._options.onError(e);
    }
    initializeSampling(e) {
      let { errorSampleRate: t, sessionSampleRate: r } = this._options,
        n = t <= 0 && r <= 0;
      if (((this._requiresManualStart = n), !n))
        (this._initializeSessionForSampling(e),
          this.session &&
            !1 !== this.session.sampled &&
            ((this.recordingMode =
              "buffer" === this.session.sampled && 0 === this.session.segmentId
                ? "buffer"
                : "session"),
            this._initializeRecording()));
    }
    start() {
      if (
        (this._isEnabled && "session" === this.recordingMode) ||
        (this._isEnabled && "buffer" === this.recordingMode)
      )
        return;
      this._updateUserActivity();
      let e = t6(
        {
          maxReplayDuration: this._options.maxReplayDuration,
          sessionIdleExpire: this.timeouts.sessionIdleExpire,
        },
        { stickySession: this._options.stickySession, sessionSampleRate: 1, allowBuffering: !1 },
      );
      ((this.session = e), (this.recordingMode = "session"), this._initializeRecording());
    }
    startBuffering() {
      if (this._isEnabled) return;
      let e = t6(
        {
          sessionIdleExpire: this.timeouts.sessionIdleExpire,
          maxReplayDuration: this._options.maxReplayDuration,
        },
        { stickySession: this._options.stickySession, sessionSampleRate: 0, allowBuffering: !0 },
      );
      ((this.session = e), (this.recordingMode = "buffer"), this._initializeRecording());
    }
    startRecording() {
      try {
        var e;
        let t,
          r = this._canvas;
        this._stopRecording = tb({
          ...this._recordingOptions,
          ...("buffer" === this.recordingMode
            ? { checkoutEveryNms: 6e4 }
            : this._options._experiments.continuousCheckout && {
                checkoutEveryNms: Math.max(36e4, this._options._experiments.continuousCheckout),
              }),
          emit:
            ((e = this),
            (t = !1),
            (r, n) => {
              if (!e.checkAndHandleExpiredSession()) return;
              let i = n || !t;
              ((t = !0),
                e.clickDetector &&
                  (function (e, t) {
                    try {
                      var r;
                      if (((r = t), 3 !== r.type)) return;
                      let { source: n } = t.data;
                      if (
                        (tT.has(n) && e.registerMutation(t.timestamp),
                        n === eY.Scroll && e.registerScroll(t.timestamp),
                        t.data.source === eY.MouseInteraction)
                      ) {
                        let { type: r, id: n } = t.data,
                          i = tb.mirror.getNode(n);
                        i instanceof HTMLElement && r === eX.Click && e.registerClick(i);
                      }
                    } catch {}
                  })(e.clickDetector, r),
                e.addUpdate(() => {
                  var t;
                  if (("buffer" === e.recordingMode && i && e.setInitialState(), !t4(e, r, i)))
                    return !0;
                  if (!i) return !1;
                  let n = e.session;
                  if (
                    ((t = e),
                    i &&
                      t.session?.segmentId === 0 &&
                      t4(
                        t,
                        (function (e) {
                          let t = e.getOptions();
                          return {
                            type: eG.Custom,
                            timestamp: Date.now(),
                            data: {
                              tag: "options",
                              payload: {
                                shouldRecordCanvas: e.isRecordingCanvas(),
                                sessionSampleRate: t.sessionSampleRate,
                                errorSampleRate: t.errorSampleRate,
                                useCompressionOption: t.useCompression,
                                blockAllMedia: t.blockAllMedia,
                                maskAllText: t.maskAllText,
                                maskAllInputs: t.maskAllInputs,
                                useCompression: !!e.eventBuffer && "worker" === e.eventBuffer.type,
                                networkDetailHasUrls: t.networkDetailAllowUrls.length > 0,
                                networkCaptureBodies: t.networkCaptureBodies,
                                networkRequestHasHeaders: t.networkRequestHeaders.length > 0,
                                networkResponseHasHeaders: t.networkResponseHeaders.length > 0,
                              },
                            },
                          };
                        })(t),
                        !1,
                      ),
                    "buffer" === e.recordingMode && n && e.eventBuffer && !n.dirty)
                  ) {
                    let t = e.eventBuffer.getEarliestTimestamp();
                    t && ((n.started = t), e.getOptions().stickySession && t0(n));
                  }
                  return !!n?.previousSessionId || ("session" === e.recordingMode && e.flush(), !0);
                }));
            }),
          ...(/iPhone|iPad|iPod/i.test(rk?.userAgent ?? "") ||
          (/Macintosh/i.test(rk?.userAgent ?? "") && rk?.maxTouchPoints && rk?.maxTouchPoints > 1)
            ? { sampling: { mousemove: !1 } }
            : {}),
          onMutation: this._onMutationHandler.bind(this),
          ...(r
            ? {
                recordCanvas: r.recordCanvas,
                getCanvasManager: r.getCanvasManager,
                sampling: r.sampling,
                dataURLOptions: r.dataURLOptions,
              }
            : {}),
        });
      } catch (e) {
        this.handleException(e);
      }
    }
    stopRecording() {
      try {
        return (this._stopRecording && (this._stopRecording(), (this._stopRecording = void 0)), !0);
      } catch (e) {
        return (this.handleException(e), !1);
      }
    }
    async stop({ forceFlush: e = !1, reason: t } = {}) {
      if (this._isEnabled) {
        ((this._isEnabled = !1), (this.recordingMode = "buffer"));
        try {
          (rn(),
            this._removeListeners(),
            this.stopRecording(),
            this._debouncedFlush.cancel(),
            e && (await this._flush({ force: !0 })),
            this.eventBuffer?.destroy(),
            (this.eventBuffer = null),
            (function () {
              if (tQ())
                try {
                  F.sessionStorage.removeItem(B);
                } catch {}
            })(),
            (this.session = void 0));
        } catch (e) {
          this.handleException(e);
        }
      }
    }
    pause() {
      this._isPaused || ((this._isPaused = !0), this.stopRecording());
    }
    resume() {
      this._isPaused && this._checkSession() && ((this._isPaused = !1), this.startRecording());
    }
    async sendBufferedReplayOrFlush({ continueRecording: e = !0 } = {}) {
      if ("session" === this.recordingMode) return this.flushImmediate();
      let t = Date.now();
      await this.flushImmediate();
      let r = this.stopRecording();
      e &&
        r &&
        "session" !== this.recordingMode &&
        ((this.recordingMode = "session"),
        this.session &&
          ((this.session.dirty = !1),
          this._updateUserActivity(t),
          this._updateSessionActivity(t),
          this._maybeSaveSession()),
        this.startRecording());
    }
    addUpdate(e) {
      let t = e();
      "buffer" !== this.recordingMode && this._isEnabled && !0 !== t && this._debouncedFlush();
    }
    triggerUserActivity() {
      if ((this._updateUserActivity(), !this._stopRecording)) {
        if (!this._checkSession()) return;
        this.resume();
        return;
      }
      (this.checkAndHandleExpiredSession(), this._updateSessionActivity());
    }
    updateUserActivity() {
      (this._updateUserActivity(), this._updateSessionActivity());
    }
    conditionalFlush() {
      return "buffer" === this.recordingMode ? Promise.resolve() : this.flushImmediate();
    }
    flush() {
      return this._debouncedFlush();
    }
    flushImmediate() {
      return (this._debouncedFlush(), this._debouncedFlush.flush());
    }
    cancelFlush() {
      this._debouncedFlush.cancel();
    }
    getSessionId(e) {
      if (!e || this.session?.sampled !== !1) return this.session?.id;
    }
    checkAndHandleExpiredSession() {
      return this._lastActivity &&
        t3(this._lastActivity, this.timeouts.sessionIdlePause) &&
        this.session?.sampled === "session"
        ? void this.pause()
        : !!this._checkSession();
    }
    setInitialState() {
      let e = `${F.location.pathname}${F.location.hash}${F.location.search}`,
        t = `${F.location.origin}${e}`;
      ((this.performanceEntries = []),
        (this.replayPerformanceEntries = []),
        this._clearContext(),
        (this._context.initialUrl = t),
        (this._context.initialTimestamp = Date.now()),
        this._context.urls.push(t));
    }
    throttledAddEvent(e, t) {
      let r = this._throttledAddEvent(e, t);
      if (r === rx) {
        let e = tN({ category: "replay.throttled" });
        this.addUpdate(
          () =>
            !t4(this, {
              type: 5,
              timestamp: e.timestamp || 0,
              data: { tag: "breadcrumb", payload: e, metric: !0 },
            }),
        );
      }
      return r;
    }
    getCurrentRoute() {
      let e = this.lastActiveSpan || (0, _.Bk)(),
        t = e && (0, _.zU)(e),
        r = ((t && (0, _.et)(t).data) || {})[R.i_];
      if (t && r && ["route", "custom"].includes(r)) return (0, _.et)(t).description;
    }
    _initializeRecording() {
      (this.setInitialState(),
        this._updateSessionActivity(),
        (this.eventBuffer = (function ({ useCompression: e, workerUrl: t }) {
          if (e && window.Worker) {
            let e = (function (e) {
              try {
                let t =
                  e ||
                  (function () {
                    if (
                      "undefined" == typeof __SENTRY_EXCLUDE_REPLAY_WORKER__ ||
                      !__SENTRY_EXCLUDE_REPLAY_WORKER__
                    ) {
                      let e = new Blob([
                        'var t=Uint8Array,n=Uint16Array,r=Int32Array,e=new t([0,0,0,0,0,0,0,0,1,1,1,1,2,2,2,2,3,3,3,3,4,4,4,4,5,5,5,5,0,0,0,0]),i=new t([0,0,0,0,1,1,2,2,3,3,4,4,5,5,6,6,7,7,8,8,9,9,10,10,11,11,12,12,13,13,0,0]),s=new t([16,17,18,0,8,7,9,6,10,5,11,4,12,3,13,2,14,1,15]),a=function(t,e){for(var i=new n(31),s=0;s<31;++s)i[s]=e+=1<<t[s-1];var a=new r(i[30]);for(s=1;s<30;++s)for(var o=i[s];o<i[s+1];++o)a[o]=o-i[s]<<5|s;return{b:i,r:a}},o=a(e,2),h=o.b,f=o.r;h[28]=258,f[258]=28;for(var l=a(i,0).r,u=new n(32768),c=0;c<32768;++c){var v=(43690&c)>>1|(21845&c)<<1;v=(61680&(v=(52428&v)>>2|(13107&v)<<2))>>4|(3855&v)<<4,u[c]=((65280&v)>>8|(255&v)<<8)>>1}var d=function(t,r,e){for(var i=t.length,s=0,a=new n(r);s<i;++s)t[s]&&++a[t[s]-1];var o,h=new n(r);for(s=1;s<r;++s)h[s]=h[s-1]+a[s-1]<<1;if(e){o=new n(1<<r);var f=15-r;for(s=0;s<i;++s)if(t[s])for(var l=s<<4|t[s],c=r-t[s],v=h[t[s]-1]++<<c,d=v|(1<<c)-1;v<=d;++v)o[u[v]>>f]=l}else for(o=new n(i),s=0;s<i;++s)t[s]&&(o[s]=u[h[t[s]-1]++]>>15-t[s]);return o},p=new t(288);for(c=0;c<144;++c)p[c]=8;for(c=144;c<256;++c)p[c]=9;for(c=256;c<280;++c)p[c]=7;for(c=280;c<288;++c)p[c]=8;var g=new t(32);for(c=0;c<32;++c)g[c]=5;var w=d(p,9,0),y=d(g,5,0),m=function(t){return(t+7)/8|0},b=function(n,r,e){return(null==e||e>n.length)&&(e=n.length),new t(n.subarray(r,e))},M=["unexpected EOF","invalid block type","invalid length/literal","invalid distance","stream finished","no stream handler",,"no callback","invalid UTF-8 data","extra field too long","date not in range 1980-2099","filename too long","stream finishing","invalid zip data"],E=function(t,n,r){var e=new Error(n||M[t]);if(e.code=t,Error.captureStackTrace&&Error.captureStackTrace(e,E),!r)throw e;return e},z=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8},_=function(t,n,r){r<<=7&n;var e=n/8|0;t[e]|=r,t[e+1]|=r>>8,t[e+2]|=r>>16},x=function(r,e){for(var i=[],s=0;s<r.length;++s)r[s]&&i.push({s:s,f:r[s]});var a=i.length,o=i.slice();if(!a)return{t:F,l:0};if(1==a){var h=new t(i[0].s+1);return h[i[0].s]=1,{t:h,l:1}}i.sort(function(t,n){return t.f-n.f}),i.push({s:-1,f:25001});var f=i[0],l=i[1],u=0,c=1,v=2;for(i[0]={s:-1,f:f.f+l.f,l:f,r:l};c!=a-1;)f=i[i[u].f<i[v].f?u++:v++],l=i[u!=c&&i[u].f<i[v].f?u++:v++],i[c++]={s:-1,f:f.f+l.f,l:f,r:l};var d=o[0].s;for(s=1;s<a;++s)o[s].s>d&&(d=o[s].s);var p=new n(d+1),g=A(i[c-1],p,0);if(g>e){s=0;var w=0,y=g-e,m=1<<y;for(o.sort(function(t,n){return p[n.s]-p[t.s]||t.f-n.f});s<a;++s){var b=o[s].s;if(!(p[b]>e))break;w+=m-(1<<g-p[b]),p[b]=e}for(w>>=y;w>0;){var M=o[s].s;p[M]<e?w-=1<<e-p[M]++-1:++s}for(;s>=0&&w;--s){var E=o[s].s;p[E]==e&&(--p[E],++w)}g=e}return{t:new t(p),l:g}},A=function(t,n,r){return-1==t.s?Math.max(A(t.l,n,r+1),A(t.r,n,r+1)):n[t.s]=r},D=function(t){for(var r=t.length;r&&!t[--r];);for(var e=new n(++r),i=0,s=t[0],a=1,o=function(t){e[i++]=t},h=1;h<=r;++h)if(t[h]==s&&h!=r)++a;else{if(!s&&a>2){for(;a>138;a-=138)o(32754);a>2&&(o(a>10?a-11<<5|28690:a-3<<5|12305),a=0)}else if(a>3){for(o(s),--a;a>6;a-=6)o(8304);a>2&&(o(a-3<<5|8208),a=0)}for(;a--;)o(s);a=1,s=t[h]}return{c:e.subarray(0,i),n:r}},T=function(t,n){for(var r=0,e=0;e<n.length;++e)r+=t[e]*n[e];return r},k=function(t,n,r){var e=r.length,i=m(n+2);t[i]=255&e,t[i+1]=e>>8,t[i+2]=255^t[i],t[i+3]=255^t[i+1];for(var s=0;s<e;++s)t[i+s+4]=r[s];return 8*(i+4+e)},U=function(t,r,a,o,h,f,l,u,c,v,m){z(r,m++,a),++h[256];for(var b=x(h,15),M=b.t,E=b.l,A=x(f,15),U=A.t,C=A.l,F=D(M),I=F.c,S=F.n,L=D(U),O=L.c,j=L.n,q=new n(19),B=0;B<I.length;++B)++q[31&I[B]];for(B=0;B<O.length;++B)++q[31&O[B]];for(var G=x(q,7),H=G.t,J=G.l,K=19;K>4&&!H[s[K-1]];--K);var N,P,Q,R,V=v+5<<3,W=T(h,p)+T(f,g)+l,X=T(h,M)+T(f,U)+l+14+3*K+T(q,H)+2*q[16]+3*q[17]+7*q[18];if(c>=0&&V<=W&&V<=X)return k(r,m,t.subarray(c,c+v));if(z(r,m,1+(X<W)),m+=2,X<W){N=d(M,E,0),P=M,Q=d(U,C,0),R=U;var Y=d(H,J,0);z(r,m,S-257),z(r,m+5,j-1),z(r,m+10,K-4),m+=14;for(B=0;B<K;++B)z(r,m+3*B,H[s[B]]);m+=3*K;for(var Z=[I,O],$=0;$<2;++$){var tt=Z[$];for(B=0;B<tt.length;++B){var nt=31&tt[B];z(r,m,Y[nt]),m+=H[nt],nt>15&&(z(r,m,tt[B]>>5&127),m+=tt[B]>>12)}}}else N=w,P=p,Q=y,R=g;for(B=0;B<u;++B){var rt=o[B];if(rt>255){_(r,m,N[(nt=rt>>18&31)+257]),m+=P[nt+257],nt>7&&(z(r,m,rt>>23&31),m+=e[nt]);var et=31&rt;_(r,m,Q[et]),m+=R[et],et>3&&(_(r,m,rt>>5&8191),m+=i[et])}else _(r,m,N[rt]),m+=P[rt]}return _(r,m,N[256]),m+P[256]},C=new r([65540,131080,131088,131104,262176,1048704,1048832,2114560,2117632]),F=new t(0),I=function(){for(var t=new Int32Array(256),n=0;n<256;++n){for(var r=n,e=9;--e;)r=(1&r&&-306674912)^r>>>1;t[n]=r}return t}(),S=function(){var t=1,n=0;return{p:function(r){for(var e=t,i=n,s=0|r.length,a=0;a!=s;){for(var o=Math.min(a+2655,s);a<o;++a)i+=e+=r[a];e=(65535&e)+15*(e>>16),i=(65535&i)+15*(i>>16)}t=e,n=i},d:function(){return(255&(t%=65521))<<24|(65280&t)<<8|(255&(n%=65521))<<8|n>>8}}},L=function(s,a,o,h,u){if(!u&&(u={l:1},a.dictionary)){var c=a.dictionary.subarray(-32768),v=new t(c.length+s.length);v.set(c),v.set(s,c.length),s=v,u.w=c.length}return function(s,a,o,h,u,c){var v=c.z||s.length,d=new t(h+v+5*(1+Math.ceil(v/7e3))+u),p=d.subarray(h,d.length-u),g=c.l,w=7&(c.r||0);if(a){w&&(p[0]=c.r>>3);for(var y=C[a-1],M=y>>13,E=8191&y,z=(1<<o)-1,_=c.p||new n(32768),x=c.h||new n(z+1),A=Math.ceil(o/3),D=2*A,T=function(t){return(s[t]^s[t+1]<<A^s[t+2]<<D)&z},F=new r(25e3),I=new n(288),S=new n(32),L=0,O=0,j=c.i||0,q=0,B=c.w||0,G=0;j+2<v;++j){var H=T(j),J=32767&j,K=x[H];if(_[J]=K,x[H]=J,B<=j){var N=v-j;if((L>7e3||q>24576)&&(N>423||!g)){w=U(s,p,0,F,I,S,O,q,G,j-G,w),q=L=O=0,G=j;for(var P=0;P<286;++P)I[P]=0;for(P=0;P<30;++P)S[P]=0}var Q=2,R=0,V=E,W=J-K&32767;if(N>2&&H==T(j-W))for(var X=Math.min(M,N)-1,Y=Math.min(32767,j),Z=Math.min(258,N);W<=Y&&--V&&J!=K;){if(s[j+Q]==s[j+Q-W]){for(var $=0;$<Z&&s[j+$]==s[j+$-W];++$);if($>Q){if(Q=$,R=W,$>X)break;var tt=Math.min(W,$-2),nt=0;for(P=0;P<tt;++P){var rt=j-W+P&32767,et=rt-_[rt]&32767;et>nt&&(nt=et,K=rt)}}}W+=(J=K)-(K=_[J])&32767}if(R){F[q++]=268435456|f[Q]<<18|l[R];var it=31&f[Q],st=31&l[R];O+=e[it]+i[st],++I[257+it],++S[st],B=j+Q,++L}else F[q++]=s[j],++I[s[j]]}}for(j=Math.max(j,B);j<v;++j)F[q++]=s[j],++I[s[j]];w=U(s,p,g,F,I,S,O,q,G,j-G,w),g||(c.r=7&w|p[w/8|0]<<3,w-=7,c.h=x,c.p=_,c.i=j,c.w=B)}else{for(j=c.w||0;j<v+g;j+=65535){var at=j+65535;at>=v&&(p[w/8|0]=g,at=v),w=k(p,w+1,s.subarray(j,at))}c.i=v}return b(d,0,h+m(w)+u)}(s,null==a.level?6:a.level,null==a.mem?u.l?Math.ceil(1.5*Math.max(8,Math.min(13,Math.log(s.length)))):20:12+a.mem,o,h,u)},O=function(t,n,r){for(;r;++n)t[n]=r,r>>>=8},j=function(){function n(n,r){if("function"==typeof n&&(r=n,n={}),this.ondata=r,this.o=n||{},this.s={l:0,i:32768,w:32768,z:32768},this.b=new t(98304),this.o.dictionary){var e=this.o.dictionary.subarray(-32768);this.b.set(e,32768-e.length),this.s.i=32768-e.length}}return n.prototype.p=function(t,n){this.ondata(L(t,this.o,0,0,this.s),n)},n.prototype.push=function(n,r){this.ondata||E(5),this.s.l&&E(4);var e=n.length+this.s.z;if(e>this.b.length){if(e>2*this.b.length-32768){var i=new t(-32768&e);i.set(this.b.subarray(0,this.s.z)),this.b=i}var s=this.b.length-this.s.z;this.b.set(n.subarray(0,s),this.s.z),this.s.z=this.b.length,this.p(this.b,!1),this.b.set(this.b.subarray(-32768)),this.b.set(n.subarray(s),32768),this.s.z=n.length-s+32768,this.s.i=32766,this.s.w=32768}else this.b.set(n,this.s.z),this.s.z+=n.length;this.s.l=1&r,(this.s.z>this.s.w+8191||r)&&(this.p(this.b,r||!1),this.s.w=this.s.i,this.s.i-=2)},n.prototype.flush=function(){this.ondata||E(5),this.s.l&&E(4),this.p(this.b,!1),this.s.w=this.s.i,this.s.i-=2},n}();function q(t,n){n||(n={});var r=function(){var t=-1;return{p:function(n){for(var r=t,e=0;e<n.length;++e)r=I[255&r^n[e]]^r>>>8;t=r},d:function(){return~t}}}(),e=t.length;r.p(t);var i,s=L(t,n,10+((i=n).filename?i.filename.length+1:0),8),a=s.length;return function(t,n){var r=n.filename;if(t[0]=31,t[1]=139,t[2]=8,t[8]=n.level<2?4:9==n.level?2:0,t[9]=3,0!=n.mtime&&O(t,4,Math.floor(new Date(n.mtime||Date.now())/1e3)),r){t[3]=8;for(var e=0;e<=r.length;++e)t[e+10]=r.charCodeAt(e)}}(s,n),O(s,a-8,r.d()),O(s,a-4,e),s}var B=function(){function t(t,n){this.c=S(),this.v=1,j.call(this,t,n)}return t.prototype.push=function(t,n){this.c.p(t),j.prototype.push.call(this,t,n)},t.prototype.p=function(t,n){var r=L(t,this.o,this.v&&(this.o.dictionary?6:2),n&&4,this.s);this.v&&(function(t,n){var r=n.level,e=0==r?0:r<6?1:9==r?3:2;if(t[0]=120,t[1]=e<<6|(n.dictionary&&32),t[1]|=31-(t[0]<<8|t[1])%31,n.dictionary){var i=S();i.p(n.dictionary),O(t,2,i.d())}}(r,this.o),this.v=0),n&&O(r,r.length-4,this.c.d()),this.ondata(r,n)},t.prototype.flush=function(){j.prototype.flush.call(this)},t}(),G="undefined"!=typeof TextEncoder&&new TextEncoder,H="undefined"!=typeof TextDecoder&&new TextDecoder;try{H.decode(F,{stream:!0})}catch(t){}var J=function(){function t(t){this.ondata=t}return t.prototype.push=function(t,n){this.ondata||E(5),this.d&&E(4),this.ondata(K(t),this.d=n||!1)},t}();function K(n,r){if(G)return G.encode(n);for(var e=n.length,i=new t(n.length+(n.length>>1)),s=0,a=function(t){i[s++]=t},o=0;o<e;++o){if(s+5>i.length){var h=new t(s+8+(e-o<<1));h.set(i),i=h}var f=n.charCodeAt(o);f<128||r?a(f):f<2048?(a(192|f>>6),a(128|63&f)):f>55295&&f<57344?(a(240|(f=65536+(1047552&f)|1023&n.charCodeAt(++o))>>18),a(128|f>>12&63),a(128|f>>6&63),a(128|63&f)):(a(224|f>>12),a(128|f>>6&63),a(128|63&f))}return b(i,0,s)}const N=new class{constructor(){this._init()}clear(){this._init()}addEvent(t){if(!t)throw new Error("Adding invalid event");const n=this._hasEvents?",":"";this.stream.push(n+t),this._hasEvents=!0}finish(){this.stream.push("]",!0);const t=function(t){let n=0;for(const r of t)n+=r.length;const r=new Uint8Array(n);for(let n=0,e=0,i=t.length;n<i;n++){const i=t[n];r.set(i,e),e+=i.length}return r}(this._deflatedData);return this._init(),t}_init(){this._hasEvents=!1,this._deflatedData=[],this.deflate=new B,this.deflate.ondata=(t,n)=>{this._deflatedData.push(t)},this.stream=new J((t,n)=>{this.deflate.push(t,n)}),this.stream.push("[")}},P={clear:()=>{N.clear()},addEvent:t=>N.addEvent(t),finish:()=>N.finish(),compress:t=>function(t){return q(K(t))}(t)};addEventListener("message",function(t){const n=t.data.method,r=t.data.id,e=t.data.arg;if(n in P&&"function"==typeof P[n])try{const t=P[n](e);postMessage({id:r,method:n,success:!0,response:t})}catch(t){postMessage({id:r,method:n,success:!1,response:t.message}),console.error(t)}}),postMessage({id:void 0,method:"init",success:!0,response:void 0});',
                      ]);
                      return URL.createObjectURL(e);
                    }
                    return "";
                  })();
                if (!t) return;
                let r = new Worker(t);
                return new tX(r);
              } catch (e) {}
            })(t);
            if (e) return e;
          }
          return new tJ();
        })({ useCompression: this._options.useCompression, workerUrl: this._options.workerUrl })),
        this._removeListeners(),
        this._addListeners(),
        (this._isEnabled = !0),
        (this._isPaused = !1),
        this.startRecording());
    }
    _initializeSessionForSampling(e) {
      let t = this._options.errorSampleRate > 0,
        r = t6(
          {
            sessionIdleExpire: this.timeouts.sessionIdleExpire,
            maxReplayDuration: this._options.maxReplayDuration,
            previousSessionId: e,
          },
          {
            stickySession: this._options.stickySession,
            sessionSampleRate: this._options.sessionSampleRate,
            allowBuffering: t,
          },
        );
      this.session = r;
    }
    _checkSession() {
      if (!this.session) return !1;
      let e = this.session;
      return (
        !t8(e, {
          sessionIdleExpire: this.timeouts.sessionIdleExpire,
          maxReplayDuration: this._options.maxReplayDuration,
        }) || (this._refreshSession(e), !1)
      );
    }
    async _refreshSession(e) {
      this._isEnabled &&
        (await this.stop({ reason: "refresh session" }), this.initializeSampling(e.id));
    }
    _addListeners() {
      try {
        (F.document.addEventListener("visibilitychange", this._handleVisibilityChange),
          F.addEventListener("blur", this._handleWindowBlur),
          F.addEventListener("focus", this._handleWindowFocus),
          F.addEventListener("keydown", this._handleKeyboardEvent),
          this.clickDetector && this.clickDetector.addListeners(),
          this._hasInitializedCoreListeners ||
            (!(function (e) {
              let t = (0, v.KU)();
              ((0, L.i)((t) => {
                var r, n;
                if (!e.isEnabled()) return;
                let i = (function (e) {
                  let { target: t, message: r } = (function (e) {
                    let t,
                      r = "click" === e.name,
                      n = null;
                    try {
                      ((n = r ? tC(e.event) : tR(e.event)),
                        (t = (0, p.Hd)(n, { maxStringLength: 200 }) || "<unknown>"));
                    } catch {
                      t = "<unknown>";
                    }
                    return { target: n, message: t };
                  })(e);
                  return tN({ category: `ui.${e.name}`, ...tP(t, r) });
                })(t);
                if (!i) return;
                let s = "click" === t.name,
                  o = s ? t.event : void 0;
                (s &&
                  e.clickDetector &&
                  o?.target &&
                  !o.altKey &&
                  !o.metaKey &&
                  !o.ctrlKey &&
                  !o.shiftKey &&
                  ((r = e.clickDetector), (n = tC(t.event)), r.handleClick(i, n)),
                  tM(e, i));
              }),
                (0, P._)((t) => {
                  if (!e.isEnabled()) return;
                  let r = (function (e) {
                    let { from: t, to: r } = e,
                      n = Date.now() / 1e3;
                    return {
                      type: "navigation.push",
                      start: n,
                      end: n,
                      name: r,
                      data: { previous: t },
                    };
                  })(t);
                  null !== r &&
                    (e.getContext().urls.push(r.name),
                    e.triggerUserActivity(),
                    e.addUpdate(() => (ri(e, [r]), !1)));
                }));
              let r = (0, v.KU)();
              r &&
                r.on("beforeAddBreadcrumb", (t) =>
                  (function (e, t) {
                    var r;
                    if (!e.isEnabled() || !rr(t)) return;
                    let n =
                      ((r = t),
                      !rr(r) ||
                      ["fetch", "xhr", "sentry.event", "sentry.transaction"].includes(r.category) ||
                      r.category.startsWith("ui.")
                        ? null
                        : "console" === r.category
                          ? (function (e) {
                              let t = e.data?.arguments;
                              if (!Array.isArray(t) || 0 === t.length) return tN(e);
                              let r = !1,
                                n = t.map((e) => {
                                  if (!e) return e;
                                  if ("string" == typeof e)
                                    return e.length > 5e3 ? ((r = !0), `${e.slice(0, 5e3)}…`) : e;
                                  if ("object" == typeof e)
                                    try {
                                      let t = (0, d.S8)(e, 7);
                                      if (JSON.stringify(t).length > 5e3)
                                        return (
                                          (r = !0),
                                          `${JSON.stringify(t, null, 2).slice(0, 5e3)}…`
                                        );
                                      return t;
                                    } catch {}
                                  return e;
                                });
                              return tN({
                                ...e,
                                data: {
                                  ...e.data,
                                  arguments: n,
                                  ...(r ? { _meta: { warnings: ["CONSOLE_ARG_TRUNCATED"] } } : {}),
                                },
                              });
                            })(r)
                          : tN(r));
                    n && tM(e, n);
                  })(e, t),
                );
              let n = (0, v.KU)();
              try {
                let {
                    networkDetailAllowUrls: t,
                    networkDetailDenyUrls: r,
                    networkCaptureBodies: i,
                    networkRequestHeaders: s,
                    networkResponseHeaders: o,
                  } = e.getOptions(),
                  a = {
                    replay: e,
                    networkDetailAllowUrls: t,
                    networkDetailDenyUrls: r,
                    networkCaptureBodies: i,
                    networkRequestHeaders: s,
                    networkResponseHeaders: o,
                  };
                n &&
                  n.on("beforeAddBreadcrumb", (e, t) =>
                    (function (e, t, r) {
                      if (t.data)
                        try {
                          var n, i, s, o;
                          if (
                            ((n = t),
                            "xhr" === n.category &&
                              ((i = r), i?.xhr) &&
                              (!(function (e, t) {
                                let { xhr: r, input: n } = t;
                                if (!r) return;
                                let i = ro(n),
                                  s = r.getResponseHeader("content-length")
                                    ? ra(r.getResponseHeader("content-length"))
                                    : (function (e, t) {
                                        try {
                                          let r =
                                            "json" === t && e && "object" == typeof e
                                              ? JSON.stringify(e)
                                              : e;
                                          return ro(r);
                                        } catch {
                                          return;
                                        }
                                      })(r.response, r.responseType);
                                (void 0 !== i && (e.data.request_body_size = i),
                                  void 0 !== s && (e.data.response_body_size = s));
                              })(t, r),
                              rw(t, r, e)),
                            (s = t),
                            "fetch" === s.category && ((o = r), o?.response))
                          ) {
                            let { input: n, response: i } = r,
                              s = ro(n ? (0, N.Gv)(n) : void 0),
                              o = i ? ra(i.headers.get("content-length")) : void 0;
                            (void 0 !== s && (t.data.request_body_size = s),
                              void 0 !== o && (t.data.response_body_size = o),
                              rf(t, r, e));
                          }
                        } catch (e) {}
                    })(a, e, t),
                  );
              } catch {}
              let i = Object.assign(
                (t, r) => {
                  if (!e.isEnabled() || e.isPaused()) return t;
                  if ("replay_event" === t.type) return (delete t.breadcrumbs, t);
                  if (t.type && !re(t) && !rt(t)) return t;
                  if (!e.checkAndHandleExpiredSession()) return (rn(), t);
                  if (rt(t))
                    return (
                      e.flush(),
                      (t.contexts.feedback.replay_id = e.getSessionId()),
                      e.triggerUserActivity(),
                      e.addUpdate(
                        () =>
                          !t.timestamp ||
                          (e.throttledAddEvent({
                            type: eG.Custom,
                            timestamp: 1e3 * t.timestamp,
                            data: {
                              tag: "breadcrumb",
                              payload: {
                                timestamp: t.timestamp,
                                type: "default",
                                category: "sentry.feedback",
                                data: { feedbackId: t.event_id },
                              },
                            },
                          }),
                          !1),
                      ),
                      t
                    );
                  if (
                    !t.type &&
                    t.exception?.values?.length &&
                    r.originalException?.__rrweb__ &&
                    !e.getOptions()._experiments.captureExceptions
                  )
                    return null;
                  let n =
                    "buffer" === e.recordingMode &&
                    t.message !== U &&
                    !!t.exception &&
                    !t.type &&
                    tZ(e.getOptions().errorSampleRate);
                  if (
                    ((n || "session" === e.recordingMode) &&
                      (t.tags = { ...t.tags, replayId: e.getSessionId() }),
                    n && "buffer" === e.recordingMode && e.session?.sampled === "buffer")
                  ) {
                    let t = e.session;
                    ((t.dirty = !0), e.getOptions().stickySession && t0(t));
                  }
                  return t;
                },
                { id: "Replay" },
              );
              ((0, g.SA)(i),
                t &&
                  (t.on("beforeSendEvent", (t) => {
                    e.isEnabled() &&
                      !t.type &&
                      (function (e, t) {
                        let r = t.exception?.values?.[0]?.value;
                        "string" == typeof r &&
                          (r.match(
                            /(reactjs\.org\/docs\/error-decoder\.html\?invariant=|react\.dev\/errors\/)(418|419|422|423|425)/,
                          ) ||
                            r.match(
                              /(does not match server-rendered HTML|Hydration failed because)/i,
                            )) &&
                          tM(
                            e,
                            tN({ category: "replay.hydrate-error", data: { url: (0, p.$N)() } }),
                          );
                      })(e, t);
                  }),
                  t.on("afterSendEvent", (t, r) => {
                    if (!e.isEnabled() || (t.type && !re(t))) return;
                    let n = r.statusCode;
                    if (n && !(n < 200) && !(n >= 300)) {
                      if (re(t))
                        return void (function (e, t) {
                          let r = e.getContext();
                          t.contexts?.trace?.trace_id &&
                            r.traceIds.size < 100 &&
                            r.traceIds.add(t.contexts.trace.trace_id);
                        })(e, t);
                      !(function (e, t) {
                        let r = e.getContext();
                        if (
                          (t.event_id && r.errorIds.size < 100 && r.errorIds.add(t.event_id),
                          "buffer" !== e.recordingMode || !t.tags?.replayId)
                        )
                          return;
                        let { beforeErrorSampling: n } = e.getOptions();
                        ("function" != typeof n || n(t)) &&
                          (0, O.wg)(async () => {
                            try {
                              await e.sendBufferedReplayOrFlush();
                            } catch (t) {
                              e.handleException(t);
                            }
                          });
                      })(e, t);
                    }
                  }),
                  t.on("createDsc", (t) => {
                    let r = e.getSessionId();
                    r &&
                      e.isEnabled() &&
                      "session" === e.recordingMode &&
                      e.checkAndHandleExpiredSession() &&
                      (t.replay_id = r);
                  }),
                  t.on("spanStart", (t) => {
                    e.lastActiveSpan = t;
                  }),
                  t.on("spanEnd", (t) => {
                    e.lastActiveSpan = t;
                  }),
                  t.on("beforeSendFeedback", async (t, r) => {
                    let n = e.getSessionId();
                    r?.includeReplay &&
                      e.isEnabled() &&
                      n &&
                      t.contexts?.feedback &&
                      ("api" === t.contexts.feedback.source &&
                        (await e.sendBufferedReplayOrFlush()),
                      (t.contexts.feedback.replay_id = n));
                  }),
                  t.on("openFeedbackWidget", async () => {
                    await e.sendBufferedReplayOrFlush();
                  })));
            })(this),
            (this._hasInitializedCoreListeners = !0)));
      } catch (e) {
        this.handleException(e);
      }
      this._performanceCleanupCallback = (function (e) {
        function t(t) {
          e.performanceEntries.includes(t) || e.performanceEntries.push(t);
        }
        function r({ entries: e }) {
          e.forEach(t);
        }
        let n = [];
        return (
          ["navigation", "paint", "resource"].forEach((e) => {
            n.push((0, D.wv)(e, r));
          }),
          n.push((0, D.Pt)(tB(tW, e)), (0, D.a9)(tB(tj, e)), (0, D.hT)(tB(tH, e))),
          () => {
            n.forEach((e) => e());
          }
        );
      })(this);
    }
    _removeListeners() {
      try {
        (F.document.removeEventListener("visibilitychange", this._handleVisibilityChange),
          F.removeEventListener("blur", this._handleWindowBlur),
          F.removeEventListener("focus", this._handleWindowFocus),
          F.removeEventListener("keydown", this._handleKeyboardEvent),
          this.clickDetector && this.clickDetector.removeListeners(),
          this._performanceCleanupCallback && this._performanceCleanupCallback());
      } catch (e) {
        this.handleException(e);
      }
    }
    _doChangeToBackgroundTasks(e) {
      this.session &&
        (t5(this.session, {
          maxReplayDuration: this._options.maxReplayDuration,
          sessionIdleExpire: this.timeouts.sessionIdleExpire,
        }) ||
          (e && this._createCustomBreadcrumb(e), this.conditionalFlush()));
    }
    _doChangeToForegroundTasks(e) {
      if (this.session) this.checkAndHandleExpiredSession() && e && this._createCustomBreadcrumb(e);
    }
    _updateUserActivity(e = Date.now()) {
      this._lastActivity = e;
    }
    _updateSessionActivity(e = Date.now()) {
      this.session && ((this.session.lastActivity = e), this._maybeSaveSession());
    }
    _createCustomBreadcrumb(e) {
      this.addUpdate(() => {
        this.throttledAddEvent({
          type: eG.Custom,
          timestamp: e.timestamp || 0,
          data: { tag: "breadcrumb", payload: e },
        });
      });
    }
    _addPerformanceEntries() {
      let e = this.performanceEntries.map(tU).filter(Boolean).concat(this.replayPerformanceEntries);
      if (
        ((this.performanceEntries = []),
        (this.replayPerformanceEntries = []),
        this._requiresManualStart)
      ) {
        let t = this._context.initialTimestamp / 1e3;
        e = e.filter((e) => e.start >= t);
      }
      return Promise.all(ri(this, e));
    }
    _clearContext() {
      (this._context.errorIds.clear(), this._context.traceIds.clear(), (this._context.urls = []));
    }
    _updateInitialTimestampFromEventBuffer() {
      let { session: e, eventBuffer: t } = this;
      if (!e || !t || this._requiresManualStart || e.segmentId) return;
      let r = t.getEarliestTimestamp();
      r && r < this._context.initialTimestamp && (this._context.initialTimestamp = r);
    }
    _popEventContext() {
      let e = {
        initialTimestamp: this._context.initialTimestamp,
        initialUrl: this._context.initialUrl,
        errorIds: Array.from(this._context.errorIds),
        traceIds: Array.from(this._context.traceIds),
        urls: this._context.urls,
      };
      return (this._clearContext(), e);
    }
    async _runFlush() {
      let e = this.getSessionId();
      if (
        this.session &&
        this.eventBuffer &&
        e &&
        (await this._addPerformanceEntries(), this.eventBuffer?.hasEvents)
      ) {
        if ((await rb(this), this.eventBuffer) && e === this.getSessionId())
          try {
            this._updateInitialTimestampFromEventBuffer();
            let t = Date.now();
            if (t - this._context.initialTimestamp > this._options.maxReplayDuration + 3e4)
              throw new rR();
            let r = this._popEventContext(),
              n = this.session.segmentId++;
            this._maybeSaveSession();
            let i = await this.eventBuffer.finish();
            await rT({
              replayId: e,
              recordingData: i,
              segmentId: n,
              eventContext: r,
              session: this.session,
              timestamp: t,
              onError: (e) => this.handleException(e),
            });
          } catch (t) {
            (this.handleException(t), this.stop({ reason: "sendReplay" }));
            let e = (0, v.KU)();
            e &&
              e.recordDroppedEvent(
                t instanceof rC ? "ratelimit_backoff" : t instanceof rR ? "invalid" : "send_error",
                "replay",
              );
          }
      }
    }
    async _flush({ force: e = !1 } = {}) {
      if ((!this._isEnabled && !e) || !this.checkAndHandleExpiredSession() || !this.session) return;
      let t = this.session.started,
        r = Date.now() - t;
      this._debouncedFlush.cancel();
      let n = r < this._options.minReplayDuration,
        i = r > this._options.maxReplayDuration + 5e3;
      if (n || i) {
        n && this._debouncedFlush();
        return;
      }
      let s = this.eventBuffer;
      s && 0 === this.session.segmentId && s.hasCheckout;
      let o = !!this._flushLock;
      this._flushLock || (this._flushLock = this._runFlush());
      try {
        await this._flushLock;
      } catch (e) {
        this.handleException(e);
      } finally {
        ((this._flushLock = void 0), o && this._debouncedFlush());
      }
    }
    _maybeSaveSession() {
      this.session && this._options.stickySession && t0(this.session);
    }
    _onMutationHandler(e) {
      let { ignoreMutations: t } = this._options._experiments;
      if (
        t?.length &&
        e.some((e) => {
          let r = (function (e) {
              if (!e) return null;
              try {
                return e.nodeType === e.ELEMENT_NODE ? e : e.parentElement;
              } catch {
                return null;
              }
            })(e.target),
            n = t.join(",");
          return r?.matches(n);
        })
      )
        return !1;
      let r = e.length,
        n = this._options.mutationLimit,
        i = this._options.mutationBreadcrumbLimit,
        s = n && r > n;
      if (r > i || s) {
        let e = tN({ category: "replay.mutations", data: { count: r, limit: s } });
        this._createCustomBreadcrumb(e);
      }
      return (
        !s ||
        (this.stop({ reason: "mutationLimit", forceFlush: "session" === this.recordingMode }), !1)
      );
    }
  }
  function rD(e, t) {
    return [...e, ...t].join(",");
  }
  let rN =
      'img,image,svg,video,object,picture,embed,map,audio,link[rel="icon"],link[rel="apple-touch-icon"]',
    rA = ["content-length", "content-type", "accept"],
    rL = Symbol.for("sentry__originalRequestBody"),
    rP = !1,
    rF = !1,
    rB = (e) => new rU(e);
  class rU {
    constructor({
      flushMinDelay: e = 5e3,
      flushMaxDelay: t = 5500,
      minReplayDuration: r = 4999,
      maxReplayDuration: n = 36e5,
      stickySession: i = !0,
      useCompression: s = !0,
      workerUrl: o,
      _experiments: a = {},
      maskAllText: l = !0,
      maskAllInputs: c = !0,
      blockAllMedia: u = !0,
      mutationBreadcrumbLimit: d = 750,
      mutationLimit: h = 1e4,
      slowClickTimeout: p = 7e3,
      slowClickIgnoreSelectors: f = [],
      networkDetailAllowUrls: m = [],
      networkDetailDenyUrls: y = [],
      networkCaptureBodies: g = !0,
      networkRequestHeaders: S = [],
      networkResponseHeaders: v = [],
      mask: _ = [],
      maskAttributes: w = ["title", "placeholder", "aria-label"],
      unmask: b = [],
      block: k = [],
      unblock: E = [],
      ignore: M = [],
      maskFn: I,
      beforeAddRecordingEvent: C,
      beforeErrorSampling: R,
      onError: x,
      attachRawBodyFromRequest: O = !1,
    } = {}) {
      this.name = "Replay";
      let D = (function ({ mask: e, unmask: t, block: r, unblock: n, ignore: i }) {
        return {
          maskTextSelector: rD(e, [".sentry-mask", "[data-sentry-mask]"]),
          unmaskTextSelector: rD(t, []),
          blockSelector: rD(r, [
            ".sentry-block",
            "[data-sentry-block]",
            "base",
            "iframe[srcdoc]:not([src])",
          ]),
          unblockSelector: rD(n, []),
          ignoreSelector: rD(i, [".sentry-ignore", "[data-sentry-ignore]", 'input[type="file"]']),
        };
      })({ mask: _, unmask: b, block: k, unblock: E, ignore: M });
      if (
        ((this._recordingOptions = {
          maskAllInputs: c,
          maskAllText: l,
          maskInputOptions: { password: !0 },
          maskTextFn: I,
          maskInputFn: I,
          maskAttributeFn: (e, t, r) =>
            (function ({
              el: e,
              key: t,
              maskAttributes: r,
              maskAllText: n,
              privacyOptions: i,
              value: s,
            }) {
              return !n || (i.unmaskTextSelector && e.matches(i.unmaskTextSelector))
                ? s
                : r.includes(t) ||
                    ("value" === t &&
                      "INPUT" === e.tagName &&
                      ["submit", "button"].includes(e.getAttribute("type") || ""))
                  ? s.replace(/[\S]/g, "*")
                  : s;
            })({ maskAttributes: w, maskAllText: l, privacyOptions: D, key: e, value: t, el: r }),
          ...D,
          slimDOMOptions: "all",
          inlineStylesheet: !0,
          inlineImages: !1,
          collectFonts: !0,
          errorHandler: (e) => {
            try {
              e.__rrweb__ = !0;
            } catch {}
          },
          recordCrossOriginIframes: !!a.recordCrossOriginIframes,
        }),
        (this._initialOptions = {
          flushMinDelay: e,
          flushMaxDelay: t,
          minReplayDuration: Math.min(r, 5e4),
          maxReplayDuration: Math.min(n, 36e5),
          stickySession: i,
          useCompression: s,
          workerUrl: o,
          blockAllMedia: u,
          maskAllInputs: c,
          maskAllText: l,
          mutationBreadcrumbLimit: d,
          mutationLimit: h,
          slowClickTimeout: p,
          slowClickIgnoreSelectors: f,
          networkDetailAllowUrls: m,
          networkDetailDenyUrls: y,
          networkCaptureBodies: g,
          networkRequestHeaders: rz(S),
          networkResponseHeaders: rz(v),
          beforeAddRecordingEvent: C,
          beforeErrorSampling: R,
          onError: x,
          attachRawBodyFromRequest: O,
          _experiments: a,
        }),
        this._initialOptions.blockAllMedia &&
          ((this._recordingOptions.blockSelector = this._recordingOptions.blockSelector
            ? `${this._recordingOptions.blockSelector},${rN}`
            : rN),
          (this._recordingOptions.ignoreCSSAttributes = new Set(["background-image"]))),
        this._isInitialized && (0, T.B)())
      )
        throw Error("Multiple Sentry Session Replay instances are not supported");
      this._isInitialized = !0;
    }
    get _isInitialized() {
      return rP;
    }
    set _isInitialized(e) {
      rP = e;
    }
    afterAllSetup(e) {
      (0, T.B)() &&
        !this._replay &&
        (this._initialOptions.attachRawBodyFromRequest &&
          (function () {
            if ("undefined" == typeof Request || rF) return;
            let e = Request;
            try {
              let t = function (t, r) {
                let n = new e(t, r);
                return (r?.body != null && (n[rL] = r.body), n);
              };
              ((t.prototype = e.prototype), (u.O.Request = t), (rF = !0));
            } catch {}
          })(),
        this._setup(e),
        this._initialize(e));
    }
    start() {
      this._replay && this._replay.start();
    }
    startBuffering() {
      this._replay && this._replay.startBuffering();
    }
    stop() {
      return this._replay
        ? this._replay.stop({ forceFlush: "session" === this._replay.recordingMode })
        : Promise.resolve();
    }
    flush(e) {
      return this._replay
        ? this._replay.isEnabled()
          ? this._replay.sendBufferedReplayOrFlush(e)
          : (this._replay.start(), Promise.resolve())
        : Promise.resolve();
    }
    getReplayId(e) {
      if (this._replay?.isEnabled()) return this._replay.getSessionId(e);
    }
    getRecordingMode() {
      if (this._replay?.isEnabled()) return this._replay.recordingMode;
    }
    _initialize(e) {
      this._replay &&
        (this._maybeLoadFromReplayCanvasIntegration(e), this._replay.initializeSampling());
    }
    _setup(e) {
      let t = (function (e, t) {
        let r = t.getOptions(),
          n = { sessionSampleRate: 0, errorSampleRate: 0, ...e },
          i = (0, x.i)(r.replaysSessionSampleRate),
          s = (0, x.i)(r.replaysOnErrorSampleRate);
        return (
          null == i &&
            null == s &&
            (0, y.pq)(() => {
              console.warn(
                "Replay is disabled because neither `replaysSessionSampleRate` nor `replaysOnErrorSampleRate` are set.",
              );
            }),
          null != i && (n.sessionSampleRate = i),
          null != s && (n.errorSampleRate = s),
          n
        );
      })(this._initialOptions, e);
      this._replay = new rO({ options: t, recordingOptions: this._recordingOptions });
    }
    _maybeLoadFromReplayCanvasIntegration(e) {
      try {
        let t = e.getIntegrationByName("ReplayCanvas");
        if (!t) return;
        this._replay._canvas = t.getOptions();
      } catch {}
    }
  }
  function rz(e) {
    return [...rA, ...e.map((e) => e.toLowerCase())];
  }
}
